/* ============================================================
   DOSSHA Cart Upsell – Dynamic Recommendation Engine
   ============================================================ */

const DOSSHA_REC_MAP = {
  "firmhold-biye-ve-buzgulu-sort-tulum-siyah": [
    "firmhold-biyeli-bra-siyah",
    "firmhold-biyeli-atlet-siyah",
    "firmhold-biye-ve-dikis-detayli-tayt-siyah",
    "firmhold-halter-yaka-tulum-siyah",
    "dossha-logolu-orta-boy-corap-beyaz"
  ],
  "firmhold-on-logo-detayli-tisort-gri": [
    "firmhold-buzgulu-tayt-gri",
    "firmhold-halter-bra-gri",
    "firmhold-halter-bra-siyah",
    "firmhold-buzgulu-tayt-siyah",
    "timeless-sac-bandi"
  ],
  "well-shaped-power-t-shirt": [
    "firmhold-buzgulu-tayt-siyah",
    "firmhold-halter-bra-siyah",
    "firmhold-halter-bra-gri",
    "firmhold-buzgulu-tayt-gri",
    "timeless-sac-bandi"
  ],
  "firmhold-buzgulu-tayt-gri": [
    "firmhold-halter-bra-gri",
    "firmhold-on-logo-detayli-tisort-gri",
    "firmhold-halter-bra-siyah",
    "timeless-sac-bandi",
    "dossha-shaker"
  ],
  "firmhold-biyeli-ince-askili-bra-deep-blue": [
    "firmhold-biye-ve-dikis-detayli-tayt-deep-blue",
    "firmhold-biyeli-atlet-deep-blue",
    "firmhold-biyeli-bra-deep-blue",
    "noct-sac-bandi",
    "dossha-shaker"
  ],
  "firmhold-biyeli-ince-askili-bra-cocoa": [
    "firmhold-biye-ve-dikis-detayli-tayt-cocoa",
    "firmhold-biyeli-atlet-cocoa",
    "firmhold-biyeli-bra-cocoa",
    "browny-sac-bandi",
    "dossha-shaker"
  ],
  "firmhold-biyeli-ince-askili-bra-siyah": [
    "firmhold-biye-ve-dikis-detayli-tayt-siyah",
    "firmhold-biyeli-bra-siyah",
    "firmhold-biyeli-atlet-siyah",
    "firmhold-halter-yaka-tulum-siyah",
    "timeless-sac-bandi"
  ],
  "firmhold-yan-kalca-sekillendirici-sort-murdum": [
    "firmhold-v-sirt-detayli-bra-murdum",
    "firmhold-burgulu-bra-murdum",
    "firmhold-atlet-murdum",
    "firmhold-kare-yaka-uzun-kol-crop-murdum",
    "firmhold-yan-kalca-sekillendirici-tayt-murdum"
  ],
  "firmhold-yan-kalca-sekillendirici-sort-antrasit": [
    "firmhold-v-sirt-detayli-bra-antrasit",
    "firmhold-burgulu-bra-antrasit",
    "firmhold-atlet-antrasit",
    "firmhold-kare-yaka-uzun-kol-crop-antrasit",
    "firmhold-yan-kalca-sekillendirici-tayt-antrasit"
  ],
  "firmhold-yan-kalca-sekillendirici-sort-beyaz": [
    "firmhold-burgulu-bra-beyaz",
    "firmhold-kare-yaka-uzun-kol-crop-beyaz",
    "firmhold-reflektor-logolu-tisort-beyaz",
    "hot-stuff-sapka-baby-blue",
    "dossha-logolu-orta-boy-corap-beyaz"
  ],
  "firmhold-yan-kalca-sekillendirici-sort-deep-red": [
    "firmhold-v-sirt-detayli-bra-deep-red",
    "firmhold-burgulu-bra-deep-red",
    "firmhold-atlet-deep-red",
    "firmhold-kare-yaka-uzun-kol-crop-deep-red",
    "midi-toka-bordo"
  ],
  "softhold-buzgulu-sort-gri": [
    "softhold-crop-tisort-gri",
    "softhold-buzgulu-sort-noct",
    "softhold-buzgulu-sort-matcha",
    "timeless-sac-bandi",
    "dossha-shaker"
  ],
  "softhold-buzgulu-sort-matcha": [
    "softhold-crop-tisort-matcha",
    "softhold-buzgulu-sort-gri",
    "softhold-buzgulu-sort-noct",
    "timeless-sac-bandi",
    "dossha-logolu-orta-boy-corap-beyaz"
  ],
  "firmhold-halter-bra-gri": [
    "firmhold-buzgulu-tayt-gri",
    "firmhold-on-logo-detayli-tisort-gri",
    "firmhold-buzgulu-tayt-siyah",
    "timeless-sac-bandi",
    "dossha-shaker"
  ],
  "firmhold-halter-bra-siyah": [
    "firmhold-buzgulu-tayt-siyah",
    "well-shaped-power-t-shirt",
    "firmhold-buzgulu-tayt-gri",
    "timeless-sac-bandi",
    "dossha-logolu-orta-boy-corap-beyaz"
  ],
  "firmhold-tayt-krem": [
    "firmhold-sirti-acik-bra-krem",
    "firmhold-crop-ceket-krem",
    "firmhold-tayt-sky-blue",
    "firmhold-sirti-acik-bra-siyah",
    "timeless-sac-bandi"
  ],
  "firmhold-tayt-sky-blue": [
    "firmhold-sirti-acik-bra-sky-blue",
    "firmhold-crop-ceket-sky-blue",
    "firmhold-tayt-krem",
    "firmhold-sirti-acik-bra-siyah",
    "dossha-logolu-orta-boy-corap-beyaz"
  ],
  "firmhold-tayt-siyah": [
    "firmhold-sirti-acik-bra-siyah",
    "firmhold-crop-ceket-siyah",
    "firmhold-tayt-krem",
    "firmhold-sirti-acik-bra-sky-blue",
    "dossha-shaker"
  ],
  "firmhold-crop-ceket-krem": [
    "firmhold-tayt-krem",
    "firmhold-sirti-acik-bra-krem",
    "firmhold-crop-ceket-siyah",
    "firmhold-crop-ceket-sky-blue",
    "timeless-sac-bandi"
  ],
  "firmhold-crop-ceket-sky-blue": [
    "firmhold-tayt-sky-blue",
    "firmhold-sirti-acik-bra-sky-blue",
    "firmhold-crop-ceket-krem",
    "firmhold-crop-ceket-siyah",
    "dossha-logolu-orta-boy-corap-beyaz"
  ],
  "firmhold-sirti-acik-bra-krem": [
    "firmhold-tayt-krem",
    "firmhold-crop-ceket-krem",
    "firmhold-sirti-acik-bra-siyah",
    "firmhold-sirti-acik-bra-sky-blue",
    "timeless-sac-bandi"
  ],
  "firmhold-sirti-acik-bra-sky-blue": [
    "firmhold-tayt-sky-blue",
    "firmhold-crop-ceket-sky-blue",
    "firmhold-sirti-acik-bra-krem",
    "firmhold-sirti-acik-bra-siyah",
    "dossha-logolu-orta-boy-corap-beyaz"
  ],
  "firmhold-sirti-acik-bra-siyah": [
    "firmhold-tayt-siyah",
    "firmhold-crop-ceket-siyah",
    "firmhold-sirti-acik-bra-krem",
    "firmhold-sirti-acik-bra-sky-blue",
    "dossha-shaker"
  ],
  "softhold-capraz-askili-v-yaka-bra-royal-green": [
    "softhold-buzgulu-kalca-sekillendirici-tayt-royal-green",
    "softhold-buzgulu-kalca-sekillendirici-tayt-siyah",
    "softhold-capraz-askili-v-yaka-bra-noct",
    "softhold-capraz-askili-v-yaka-bra-acik-gri",
    "dossha-logolu-orta-boy-corap-beyaz"
  ],
  "softhold-buzgulu-kalca-sekillendirici-tayt-royal-green": [
    "softhold-capraz-askili-v-yaka-bra-royal-green",
    "softhold-capraz-askili-v-yaka-bra-siyah",
    "softhold-buzgulu-kalca-sekillendirici-tayt-noct",
    "softhold-buzgulu-kalca-sekillendirici-tayt-acik-gri",
    "dossha-shaker"
  ],
  "firmhold-v-sirt-detayli-bra-murdum": [
    "firmhold-yan-kalca-sekillendirici-tayt-murdum",
    "firmhold-atlet-murdum",
    "firmhold-kare-yaka-uzun-kol-crop-murdum",
    "firmhold-yan-kalca-sekillendirici-sort-murdum",
    "easemove-beli-katlamali-pantolon-murdum"
  ],
  "firmhold-v-sirt-detayli-bra-antrasit": [
    "firmhold-yan-kalca-sekillendirici-tayt-antrasit",
    "firmhold-atlet-antrasit",
    "firmhold-kare-yaka-uzun-kol-crop-antrasit",
    "firmhold-yan-kalca-sekillendirici-sort-antrasit",
    "easemove-beli-katlamali-pantolon-antrasit"
  ],
  "firmhold-v-sirt-detayli-bra-deep-red": [
    "firmhold-yan-kalca-sekillendirici-tayt-deep-red",
    "firmhold-atlet-deep-red",
    "firmhold-kare-yaka-uzun-kol-crop-deep-red",
    "firmhold-yan-kalca-sekillendirici-sort-deep-red",
    "maxi-toka-bordo"
  ],
  "firmhold-biyeli-bra-deep-blue": [
    "firmhold-biye-ve-dikis-detayli-tayt-deep-blue",
    "firmhold-biyeli-atlet-deep-blue",
    "firmhold-biyeli-ince-askili-bra-deep-blue",
    "noct-sac-bandi",
    "dossha-shaker"
  ],
  "firmhold-biyeli-bra-cocoa": [
    "firmhold-biye-ve-dikis-detayli-tayt-cocoa",
    "firmhold-biyeli-atlet-cocoa",
    "firmhold-biyeli-ince-askili-bra-cocoa",
    "browny-sac-bandi",
    "dossha-logolu-orta-boy-corap-beyaz"
  ],
  "firmhold-biyeli-bra-siyah": [
    "firmhold-biye-ve-dikis-detayli-tayt-siyah",
    "firmhold-biyeli-atlet-siyah",
    "firmhold-biyeli-ince-askili-bra-siyah",
    "firmhold-halter-yaka-tulum-siyah",
    "timeless-sac-bandi"
  ],
  "timeless-sac-bandi": [
    "firmhold-buzgulu-tayt-gri",
    "softhold-buzgulu-sort-gri",
    "firmhold-halter-bra-gri",
    "firmhold-tayt-krem",
    "dossha-shaker"
  ],
  "browny-sac-bandi": [
    "firmhold-biye-ve-dikis-detayli-tayt-cocoa",
    "firmhold-biyeli-bra-cocoa",
    "softhold-buzgulu-sort-browny",
    "softhold-crop-tisort-browny",
    "dossha-shaker"
  ],
  "noct-sac-bandi": [
    "softhold-buzgulu-kalca-sekillendirici-tayt-noct",
    "softhold-capraz-askili-v-yaka-bra-noct",
    "softhold-buzgulu-sort-noct",
    "softhold-crop-tisort-noct",
    "dossha-logolu-orta-boy-corap-beyaz"
  ],
  "cherry-berry-sac-bandi": [
    "softhold-buzgulu-kalca-sekillendirici-tayt-cherry",
    "softhold-capraz-askili-v-yaka-bra-cherry",
    "softhold-buzgulu-sort-cherry",
    "softhold-crop-tisort-cherry",
    "dossha-shaker"
  ],
  "dossha-shaker": [
    "dossha-logolu-orta-boy-corap-beyaz",
    "termos-paslanmaz-celik",
    "hot-stuff-sapka-baby-blue",
    "timeless-sac-bandi",
    "sac-bandi-siyah"
  ],
  "dossha-logolu-orta-boy-corap-beyaz": [
    "dossha-shaker",
    "termos-paslanmaz-celik",
    "dossha-logolu-bilek-boy-corap-beyaz",
    "timeless-sac-bandi",
    "firmhold-biye-ve-dikis-detayli-tayt-siyah"
  ],
  "firmhold-biyeli-atlet-deep-blue": [
    "firmhold-biye-ve-dikis-detayli-tayt-deep-blue",
    "firmhold-biyeli-bra-deep-blue",
    "firmhold-biyeli-ince-askili-bra-deep-blue",
    "noct-sac-bandi",
    "dossha-shaker"
  ],
  "firmhold-biyeli-atlet-cocoa": [
    "firmhold-biye-ve-dikis-detayli-tayt-cocoa",
    "firmhold-biyeli-bra-cocoa",
    "firmhold-biyeli-ince-askili-bra-cocoa",
    "browny-sac-bandi",
    "dossha-shaker"
  ],
  "firmhold-biyeli-atlet-siyah": [
    "firmhold-biye-ve-dikis-detayli-tayt-siyah",
    "firmhold-biyeli-bra-siyah",
    "firmhold-biyeli-ince-askili-bra-siyah",
    "timeless-sac-bandi",
    "firmhold-halter-yaka-tulum-siyah"
  ],
  "firmhold-atlet-murdum": [
    "firmhold-yan-kalca-sekillendirici-tayt-murdum",
    "firmhold-v-sirt-detayli-bra-murdum",
    "firmhold-kare-yaka-uzun-kol-crop-murdum",
    "firmhold-yan-kalca-sekillendirici-sort-murdum",
    "easemove-beli-katlamali-pantolon-murdum"
  ],
  "firmhold-atlet-antrasit": [
    "firmhold-yan-kalca-sekillendirici-tayt-antrasit",
    "firmhold-v-sirt-detayli-bra-antrasit",
    "firmhold-kare-yaka-uzun-kol-crop-antrasit",
    "firmhold-yan-kalca-sekillendirici-sort-antrasit",
    "easemove-beli-katlamali-pantolon-antrasit"
  ],
  "firmhold-atlet-deep-red": [
    "firmhold-yan-kalca-sekillendirici-tayt-deep-red",
    "firmhold-v-sirt-detayli-bra-deep-red",
    "firmhold-kare-yaka-uzun-kol-crop-deep-red",
    "firmhold-yan-kalca-sekillendirici-sort-deep-red",
    "midi-toka-bordo"
  ],
  "firmhold-burgulu-bra-murdum": [
    "firmhold-yan-kalca-sekillendirici-tayt-murdum",
    "firmhold-atlet-murdum",
    "firmhold-kare-yaka-uzun-kol-crop-murdum",
    "firmhold-yan-kalca-sekillendirici-sort-murdum",
    "easemove-beli-katlamali-pantolon-murdum"
  ],
  "firmhold-burgulu-bra-antrasit": [
    "firmhold-yan-kalca-sekillendirici-tayt-antrasit",
    "firmhold-atlet-antrasit",
    "firmhold-kare-yaka-uzun-kol-crop-antrasit",
    "firmhold-yan-kalca-sekillendirici-sort-antrasit",
    "easemove-beli-katlamali-pantolon-antrasit"
  ],
  "firmhold-burgulu-bra-beyaz": [
    "firmhold-kare-yaka-uzun-kol-crop-beyaz",
    "firmhold-reflektor-logolu-tisort-beyaz",
    "firmhold-yan-kalca-sekillendirici-sort-beyaz",
    "ciao-amore-sapka-krem",
    "dossha-logolu-orta-boy-corap-beyaz"
  ],
  "firmhold-burgulu-bra-deep-red": [
    "firmhold-yan-kalca-sekillendirici-tayt-deep-red",
    "firmhold-atlet-deep-red",
    "firmhold-kare-yaka-uzun-kol-crop-deep-red",
    "firmhold-yan-kalca-sekillendirici-sort-deep-red",
    "maxi-toka-bordo"
  ],
  "firmhold-crop-ceket-siyah": [
    "firmhold-tayt-siyah",
    "firmhold-sirti-acik-bra-siyah",
    "firmhold-crop-ceket-krem",
    "firmhold-crop-ceket-sky-blue",
    "timeless-sac-bandi"
  ],
  "firmhold-kare-yaka-uzun-kol-crop-murdum": [
    "firmhold-yan-kalca-sekillendirici-tayt-murdum",
    "firmhold-v-sirt-detayli-bra-murdum",
    "firmhold-atlet-murdum",
    "firmhold-yan-kalca-sekillendirici-sort-murdum",
    "easemove-beli-katlamali-pantolon-murdum"
  ],
  "firmhold-kare-yaka-uzun-kol-crop-antrasit": [
    "firmhold-yan-kalca-sekillendirici-tayt-antrasit",
    "firmhold-v-sirt-detayli-bra-antrasit",
    "firmhold-atlet-antrasit",
    "firmhold-yan-kalca-sekillendirici-sort-antrasit",
    "easemove-beli-katlamali-pantolon-antrasit"
  ],
  "firmhold-kare-yaka-uzun-kol-crop-beyaz": [
    "firmhold-burgulu-bra-beyaz",
    "firmhold-reflektor-logolu-tisort-beyaz",
    "firmhold-yan-kalca-sekillendirici-sort-beyaz",
    "hot-stuff-sapka-baby-blue",
    "dossha-logolu-orta-boy-corap-beyaz"
  ],
  "firmhold-kare-yaka-uzun-kol-crop-deep-red": [
    "firmhold-yan-kalca-sekillendirici-tayt-deep-red",
    "firmhold-v-sirt-detayli-bra-deep-red",
    "firmhold-atlet-deep-red",
    "firmhold-yan-kalca-sekillendirici-sort-deep-red",
    "midi-toka-bordo"
  ],
  "firmhold-biye-ve-dikis-detayli-tayt-siyah": [
    "firmhold-biyeli-bra-siyah",
    "firmhold-biyeli-atlet-siyah",
    "firmhold-biyeli-ince-askili-bra-siyah",
    "firmhold-halter-yaka-tulum-siyah",
    "timeless-sac-bandi"
  ],
  "easemove-beli-katlamali-pantolon-deep-red": [
    "firmhold-v-sirt-detayli-bra-deep-red",
    "firmhold-atlet-deep-red",
    "firmhold-kare-yaka-uzun-kol-crop-deep-red",
    "firmhold-yan-kalca-sekillendirici-tayt-deep-red",
    "maxi-toka-bordo"
  ],
  "easemove-beli-katlamali-pantolon-antrasit": [
    "firmhold-v-sirt-detayli-bra-antrasit",
    "firmhold-atlet-antrasit",
    "firmhold-kare-yaka-uzun-kol-crop-antrasit",
    "firmhold-yan-kalca-sekillendirici-tayt-antrasit",
    "firmhold-yan-kalca-sekillendirici-sort-antrasit"
  ],
  "firmhold-reflektor-logolu-tisort-beyaz": [
    "firmhold-yan-kalca-sekillendirici-sort-beyaz",
    "firmhold-burgulu-bra-beyaz",
    "firmhold-kare-yaka-uzun-kol-crop-beyaz",
    "ciao-amore-sapka-krem",
    "dossha-logolu-orta-boy-corap-beyaz"
  ],
  "softhold-crop-tisort-gri": [
    "softhold-buzgulu-sort-gri",
    "softhold-crop-tisort-matcha",
    "softhold-crop-tisort-noct",
    "timeless-sac-bandi",
    "dossha-shaker"
  ],
  "softhold-crop-tisort-noct": [
    "softhold-buzgulu-sort-noct",
    "noct-sac-bandi",
    "softhold-crop-tisort-gri",
    "softhold-buzgulu-kalca-sekillendirici-tayt-noct",
    "dossha-logolu-orta-boy-corap-beyaz"
  ],
  "softhold-crop-tisort-browny": [
    "softhold-buzgulu-sort-browny",
    "browny-sac-bandi",
    "softhold-crop-tisort-gri",
    "firmhold-biye-ve-dikis-detayli-tayt-cocoa",
    "dossha-shaker"
  ],
  "softhold-crop-tisort-matcha": [
    "softhold-buzgulu-sort-matcha",
    "softhold-crop-tisort-gri",
    "softhold-crop-tisort-noct",
    "timeless-sac-bandi",
    "dossha-logolu-orta-boy-corap-beyaz"
  ],
  "softhold-buzgulu-sort-noct": [
    "softhold-crop-tisort-noct",
    "noct-sac-bandi",
    "softhold-buzgulu-sort-gri",
    "softhold-capraz-askili-v-yaka-bra-noct",
    "dossha-shaker"
  ],
  "softhold-buzgulu-sort-browny": [
    "softhold-crop-tisort-browny",
    "browny-sac-bandi",
    "softhold-buzgulu-sort-gri",
    "firmhold-biyeli-bra-cocoa",
    "dossha-logolu-orta-boy-corap-beyaz"
  ],
  "softhold-crop-tisort-cherry": [
    "softhold-buzgulu-sort-cherry",
    "cherry-berry-sac-bandi",
    "softhold-crop-tisort-gri",
    "softhold-buzgulu-kalca-sekillendirici-tayt-cherry",
    "dossha-shaker"
  ],
  "softhold-buzgulu-sort-cherry": [
    "softhold-crop-tisort-cherry",
    "cherry-berry-sac-bandi",
    "softhold-buzgulu-sort-gri",
    "softhold-capraz-askili-v-yaka-bra-cherry",
    "dossha-logolu-orta-boy-corap-beyaz"
  ],
  "softhold-capraz-askili-v-yaka-bra-siyah": [
    "softhold-buzgulu-kalca-sekillendirici-tayt-siyah",
    "softhold-buzgulu-kalca-sekillendirici-tayt-royal-green",
    "softhold-capraz-askili-v-yaka-bra-noct",
    "dossha-shaker",
    "dossha-logolu-orta-boy-corap-beyaz"
  ],
  "softhold-capraz-askili-v-yaka-bra-cherry": [
    "softhold-buzgulu-kalca-sekillendirici-tayt-cherry",
    "cherry-berry-sac-bandi",
    "softhold-buzgulu-sort-cherry",
    "softhold-buzgulu-kalca-sekillendirici-tayt-siyah",
    "dossha-shaker"
  ],
  "softhold-buzgulu-kalca-sekillendirici-tayt-siyah": [
    "softhold-capraz-askili-v-yaka-bra-siyah",
    "softhold-capraz-askili-v-yaka-bra-royal-green",
    "softhold-buzgulu-kalca-sekillendirici-tayt-noct",
    "dossha-shaker",
    "dossha-logolu-orta-boy-corap-beyaz"
  ],
  "softhold-buzgulu-kalca-sekillendirici-tayt-cherry": [
    "softhold-capraz-askili-v-yaka-bra-cherry",
    "cherry-berry-sac-bandi",
    "softhold-crop-tisort-cherry",
    "softhold-capraz-askili-v-yaka-bra-siyah",
    "dossha-shaker"
  ],
  "easemove-beli-katlamali-pantolon-murdum": [
    "firmhold-v-sirt-detayli-bra-murdum",
    "firmhold-atlet-murdum",
    "firmhold-kare-yaka-uzun-kol-crop-murdum",
    "firmhold-yan-kalca-sekillendirici-tayt-murdum",
    "firmhold-yan-kalca-sekillendirici-sort-murdum"
  ],
  "softhold-capraz-askili-v-yaka-bra-baby-pink": [
    "softhold-buzgulu-kalca-sekillendirici-tayt-baby-pink",
    "softhold-capraz-askili-v-yaka-bra-acik-gri",
    "softhold-capraz-askili-v-yaka-bra-taupe",
    "softhold-buzgulu-kalca-sekillendirici-tayt-siyah",
    "dossha-logolu-orta-boy-corap-beyaz"
  ],
  "softhold-capraz-askili-v-yaka-bra-acik-gri": [
    "softhold-buzgulu-kalca-sekillendirici-tayt-acik-gri",
    "softhold-capraz-askili-v-yaka-bra-baby-pink",
    "softhold-capraz-askili-v-yaka-bra-noct",
    "softhold-buzgulu-kalca-sekillendirici-tayt-siyah",
    "dossha-shaker"
  ],
  "softhold-capraz-askili-v-yaka-bra-taupe": [
    "softhold-buzgulu-kalca-sekillendirici-tayt-taupe",
    "softhold-capraz-askili-v-yaka-bra-acik-gri",
    "softhold-capraz-askili-v-yaka-bra-cherry",
    "softhold-buzgulu-kalca-sekillendirici-tayt-siyah",
    "dossha-logolu-orta-boy-corap-beyaz"
  ],
  "softhold-capraz-askili-v-yaka-bra-noct": [
    "softhold-buzgulu-kalca-sekillendirici-tayt-noct",
    "noct-sac-bandi",
    "softhold-buzgulu-sort-noct",
    "softhold-buzgulu-kalca-sekillendirici-tayt-siyah",
    "dossha-shaker"
  ],
  "softhold-buzgulu-kalca-sekillendirici-tayt-baby-pink": [
    "softhold-capraz-askili-v-yaka-bra-baby-pink",
    "softhold-buzgulu-kalca-sekillendirici-tayt-acik-gri",
    "softhold-buzgulu-kalca-sekillendirici-tayt-taupe",
    "softhold-capraz-askili-v-yaka-bra-siyah",
    "dossha-shaker"
  ],
  "softhold-buzgulu-kalca-sekillendirici-tayt-acik-gri": [
    "softhold-capraz-askili-v-yaka-bra-acik-gri",
    "softhold-buzgulu-kalca-sekillendirici-tayt-baby-pink",
    "softhold-buzgulu-kalca-sekillendirici-tayt-noct",
    "softhold-capraz-askili-v-yaka-bra-siyah",
    "dossha-logolu-orta-boy-corap-beyaz"
  ],
  "softhold-buzgulu-kalca-sekillendirici-tayt-taupe": [
    "softhold-capraz-askili-v-yaka-bra-taupe",
    "softhold-buzgulu-kalca-sekillendirici-tayt-acik-gri",
    "softhold-buzgulu-kalca-sekillendirici-tayt-cherry",
    "softhold-capraz-askili-v-yaka-bra-siyah",
    "dossha-shaker"
  ],
  "sweatshirt-gri": [
    "lounge-kabartma-logolu-jogger-gri-melanj",
    "lounge-kabartma-logolu-hoodie-gri-melanj",
    "lounge-kabartma-logolu-wide-leg-esofman-gri-melanj",
    "hot-stuff-sapka-baby-blue",
    "dossha-logolu-orta-boy-corap-beyaz"
  ],
  "sweatshirt-ekru": [
    "lounge-kabartma-logolu-jogger-ekru",
    "lounge-kabartma-logolu-sweatshirt-ekru",
    "lounge-logo-nakisli-sort-off-white",
    "lounge-logo-nakisli-crop-tisort-off-white",
    "midi-toka-vanilya"
  ],
  "firmhold-yan-kalca-sekillendirici-tayt-deep-red": [
    "firmhold-v-sirt-detayli-bra-deep-red",
    "firmhold-atlet-deep-red",
    "firmhold-kare-yaka-uzun-kol-crop-deep-red",
    "firmhold-yan-kalca-sekillendirici-sort-deep-red",
    "midi-toka-bordo"
  ],
  "firmhold-yan-kalca-sekillendirici-tayt-antrasit": [
    "firmhold-v-sirt-detayli-bra-antrasit",
    "firmhold-atlet-antrasit",
    "firmhold-kare-yaka-uzun-kol-crop-antrasit",
    "firmhold-yan-kalca-sekillendirici-sort-antrasit",
    "easemove-beli-katlamali-pantolon-antrasit"
  ],
  "firmhold-biye-ve-dikis-detayli-tayt-deep-blue": [
    "firmhold-biyeli-bra-deep-blue",
    "firmhold-biyeli-atlet-deep-blue",
    "firmhold-biyeli-ince-askili-bra-deep-blue",
    "noct-sac-bandi",
    "dossha-shaker"
  ],
  "firmhold-biye-ve-dikis-detayli-tayt-cocoa": [
    "firmhold-biyeli-bra-cocoa",
    "firmhold-biyeli-atlet-cocoa",
    "firmhold-biyeli-ince-askili-bra-cocoa",
    "browny-sac-bandi",
    "dossha-logolu-orta-boy-corap-beyaz"
  ],
  "firmhold-yan-kalca-sekillendirici-tayt-murdum": [
    "firmhold-v-sirt-detayli-bra-murdum",
    "firmhold-atlet-murdum",
    "firmhold-kare-yaka-uzun-kol-crop-murdum",
    "firmhold-yan-kalca-sekillendirici-sort-murdum",
    "easemove-beli-katlamali-pantolon-murdum"
  ],
  "softhold-buzgulu-kalca-sekillendirici-tayt-noct": [
    "softhold-capraz-askili-v-yaka-bra-noct",
    "noct-sac-bandi",
    "softhold-buzgulu-sort-noct",
    "softhold-capraz-askili-v-yaka-bra-siyah",
    "dossha-shaker"
  ],
  "firmhold-buzgulu-tayt-siyah": [
    "firmhold-halter-bra-siyah",
    "well-shaped-power-t-shirt",
    "firmhold-buzgulu-tayt-gri",
    "timeless-sac-bandi",
    "dossha-logolu-orta-boy-corap-beyaz"
  ],
  "firmhold-halter-yaka-tulum-siyah": [
    "firmhold-biyeli-bra-siyah",
    "firmhold-biyeli-atlet-siyah",
    "firmhold-biye-ve-dikis-detayli-tayt-siyah",
    "firmhold-biyeli-ince-askili-bra-siyah",
    "timeless-sac-bandi"
  ],
  "firmhold-burgulu-bra-baby-blue": [
    "firmhold-yan-kalca-sekillendirici-tayt-baby-blue",
    "firmhold-v-sirt-detayli-bra-baby-blue",
    "it-girl-baby-blue-ceket",
    "firmhold-kare-yaka-uzun-kol-crop-baby-blue",
    "firmhold-yan-kalca-sekillendirici-sort-baby-blue"
  ],
  "firmhold-yan-kalca-sekillendirici-tayt-baby-blue": [
    "firmhold-v-sirt-detayli-bra-baby-blue",
    "firmhold-burgulu-bra-baby-blue",
    "it-girl-baby-blue-ceket",
    "firmhold-kare-yaka-uzun-kol-crop-baby-blue",
    "firmhold-yan-kalca-sekillendirici-sort-baby-blue"
  ],
  "firmhold-kare-yaka-uzun-kol-crop-baby-blue": [
    "firmhold-yan-kalca-sekillendirici-tayt-baby-blue",
    "firmhold-v-sirt-detayli-bra-baby-blue",
    "it-girl-baby-blue-ceket",
    "firmhold-yan-kalca-sekillendirici-sort-baby-blue",
    "firmhold-burgulu-bra-baby-blue"
  ],
  "it-girl-baby-blue-ceket": [
    "firmhold-yan-kalca-sekillendirici-tayt-baby-blue",
    "firmhold-v-sirt-detayli-bra-baby-blue",
    "firmhold-kare-yaka-uzun-kol-crop-baby-blue",
    "firmhold-yan-kalca-sekillendirici-sort-baby-blue",
    "firmhold-burgulu-bra-baby-blue"
  ],
  "firmhold-yan-kalca-sekillendirici-sort-baby-blue": [
    "firmhold-yan-kalca-sekillendirici-tayt-baby-blue",
    "firmhold-v-sirt-detayli-bra-baby-blue",
    "it-girl-baby-blue-ceket",
    "firmhold-kare-yaka-uzun-kol-crop-baby-blue",
    "firmhold-burgulu-bra-baby-blue"
  ],
  "firmhold-burgulu-bra-butter-yellow": [
    "firmhold-yan-kalca-sekillendirici-tayt-butter-yellow",
    "firmhold-v-sirt-detayli-bra-butter-yellow",
    "it-girl-butter-yellow-ceket",
    "firmhold-kare-yaka-uzun-kol-crop-butter-yellow",
    "firmhold-yan-kalca-sekillendirici-sort-butter-yellow"
  ],
  "firmhold-yan-kalca-sekillendirici-tayt-butter-yellow": [
    "firmhold-v-sirt-detayli-bra-butter-yellow",
    "firmhold-burgulu-bra-butter-yellow",
    "it-girl-butter-yellow-ceket",
    "firmhold-kare-yaka-uzun-kol-crop-butter-yellow",
    "firmhold-yan-kalca-sekillendirici-sort-butter-yellow"
  ],
  "firmhold-kare-yaka-uzun-kol-crop-butter-yellow": [
    "firmhold-yan-kalca-sekillendirici-tayt-butter-yellow",
    "firmhold-v-sirt-detayli-bra-butter-yellow",
    "it-girl-butter-yellow-ceket",
    "firmhold-yan-kalca-sekillendirici-sort-butter-yellow",
    "firmhold-burgulu-bra-butter-yellow"
  ],
  "it-girl-butter-yellow-ceket": [
    "firmhold-yan-kalca-sekillendirici-tayt-butter-yellow",
    "firmhold-v-sirt-detayli-bra-butter-yellow",
    "firmhold-kare-yaka-uzun-kol-crop-butter-yellow",
    "firmhold-yan-kalca-sekillendirici-sort-butter-yellow",
    "firmhold-burgulu-bra-butter-yellow"
  ],
  "firmhold-yan-kalca-sekillendirici-sort-butter-yellow": [
    "firmhold-yan-kalca-sekillendirici-tayt-butter-yellow",
    "firmhold-v-sirt-detayli-bra-butter-yellow",
    "it-girl-butter-yellow-ceket",
    "firmhold-kare-yaka-uzun-kol-crop-butter-yellow",
    "firmhold-burgulu-bra-butter-yellow"
  ],
  "firmhold-burgulu-bra-siyah": [
    "firmhold-kare-yaka-uzun-kol-crop-siyah",
    "firmhold-yan-kalca-sekillendirici-sort-siyah",
    "firmhold-biye-ve-dikis-detayli-tayt-siyah",
    "firmhold-parmak-detayli-ceket-siyah",
    "dossha-logolu-orta-boy-corap-beyaz"
  ],
  "firmhold-kare-yaka-uzun-kol-crop-siyah": [
    "firmhold-burgulu-bra-siyah",
    "firmhold-yan-kalca-sekillendirici-sort-siyah",
    "firmhold-biye-ve-dikis-detayli-tayt-siyah",
    "firmhold-v-yaka-halter-atlet-siyah",
    "dossha-shaker"
  ],
  "firmhold-yan-kalca-sekillendirici-sort-siyah": [
    "firmhold-burgulu-bra-siyah",
    "firmhold-kare-yaka-uzun-kol-crop-siyah",
    "firmhold-halter-yaka-tulum-siyah",
    "firmhold-bra-siyah",
    "dossha-logolu-orta-boy-corap-beyaz"
  ],
  "ciao-amore-sapka-krem": [
    "termos-paslanmaz-celik",
    "dossha-shaker",
    "firmhold-reflektor-logolu-tisort-beyaz",
    "easemove-tenis-elbisesi-beyaz",
    "dossha-logolu-orta-boy-corap-beyaz"
  ],
  "hot-stuff-sapka-baby-blue": [
    "termos-paslanmaz-celik",
    "dossha-shaker",
    "firmhold-yan-kalca-sekillendirici-sort-siyah",
    "firmhold-parmak-detayli-ceket-siyah",
    "dossha-logolu-orta-boy-corap-beyaz"
  ],
  "firmhold-v-sirt-detayli-bra-baby-blue": [
    "firmhold-yan-kalca-sekillendirici-tayt-baby-blue",
    "it-girl-baby-blue-ceket",
    "firmhold-kare-yaka-uzun-kol-crop-baby-blue",
    "firmhold-yan-kalca-sekillendirici-sort-baby-blue",
    "firmhold-burgulu-bra-baby-blue"
  ],
  "firmhold-v-sirt-detayli-bra-butter-yellow": [
    "firmhold-yan-kalca-sekillendirici-tayt-butter-yellow",
    "it-girl-butter-yellow-ceket",
    "firmhold-kare-yaka-uzun-kol-crop-butter-yellow",
    "firmhold-yan-kalca-sekillendirici-sort-butter-yellow",
    "firmhold-burgulu-bra-butter-yellow"
  ],
  "softhold-capraz-sirt-detayli-atlet-siyah": [
    "softhold-dikis-detayli-tayt-siyah",
    "softhold-ince-askili-bra-siyah",
    "softhold-buzgulu-halter-bra-siyah",
    "softhold-dikis-detayli-sort-siyah",
    "lounge-baglama-bolero-siyah"
  ],
  "softhold-capraz-sirt-detayli-atlet-kahverengi": [
    "softhold-dikis-detayli-tayt-kahverengi",
    "softhold-ince-askili-bra-kahverengi",
    "softhold-buzgulu-halter-bra-kahverengi",
    "softhold-dikis-detayli-sort-kahverengi",
    "lounge-baglama-bolero-kahverengi"
  ],
  "softhold-capraz-sirt-detayli-atlet-gul-kurusu": [
    "softhold-dikis-detayli-tayt-gul-kurusu",
    "softhold-ince-askili-bra-gul-kurusu",
    "softhold-buzgulu-halter-bra-gul-kurusu",
    "softhold-dikis-detayli-sort-gul-kurusu",
    "lounge-baglama-bolero-gul-kurusu"
  ],
  "softhold-capraz-sirt-detayli-atlet-yesil": [
    "softhold-dikis-detayli-tayt-yesil",
    "softhold-ince-askili-bra-yesil",
    "softhold-buzgulu-halter-bra-yesil",
    "softhold-dikis-detayli-sort-yesil",
    "easemove-sirt-dekolteli-sort-tulum-yesil"
  ],
  "softhold-capraz-sirt-detayli-atlet-beyaz": [
    "softhold-ince-askili-bra-beyaz",
    "softhold-buzgulu-halter-bra-beyaz",
    "lounge-baglama-bolero-ekru",
    "lounge-kabartma-logolu-hoodie-off-white",
    "dossha-shaker"
  ],
  "softhold-ince-askili-bra-siyah": [
    "softhold-dikis-detayli-tayt-siyah",
    "softhold-capraz-sirt-detayli-atlet-siyah",
    "softhold-buzgulu-halter-bra-siyah",
    "softhold-dikis-detayli-sort-siyah",
    "lounge-baglama-bolero-siyah"
  ],
  "softhold-ince-askili-bra-kahverengi": [
    "softhold-dikis-detayli-tayt-kahverengi",
    "softhold-capraz-sirt-detayli-atlet-kahverengi",
    "softhold-buzgulu-halter-bra-kahverengi",
    "softhold-dikis-detayli-sort-kahverengi",
    "lounge-baglama-bolero-kahverengi"
  ],
  "softhold-ince-askili-bra-gul-kurusu": [
    "softhold-dikis-detayli-tayt-gul-kurusu",
    "softhold-capraz-sirt-detayli-atlet-gul-kurusu",
    "softhold-buzgulu-halter-bra-gul-kurusu",
    "softhold-dikis-detayli-sort-gul-kurusu",
    "lounge-baglama-bolero-gul-kurusu"
  ],
  "softhold-ince-askili-bra-yesil": [
    "softhold-dikis-detayli-tayt-yesil",
    "softhold-capraz-sirt-detayli-atlet-yesil",
    "softhold-buzgulu-halter-bra-yesil",
    "softhold-dikis-detayli-sort-yesil",
    "easemove-sirt-dekolteli-sort-tulum-yesil"
  ],
  "softhold-ince-askili-bra-beyaz": [
    "softhold-capraz-sirt-detayli-atlet-beyaz",
    "softhold-buzgulu-halter-bra-beyaz",
    "lounge-baglama-bolero-ekru",
    "lounge-kabartma-logolu-wide-leg-esofman-off-white",
    "dossha-logolu-orta-boy-corap-beyaz"
  ],
  "softhold-buzgulu-halter-bra-siyah": [
    "softhold-dikis-detayli-tayt-siyah",
    "softhold-ince-askili-bra-siyah",
    "softhold-capraz-sirt-detayli-atlet-siyah",
    "softhold-dikis-detayli-sort-siyah",
    "lounge-baglama-bolero-siyah"
  ],
  "softhold-buzgulu-halter-bra-kahverengi": [
    "softhold-dikis-detayli-tayt-kahverengi",
    "softhold-ince-askili-bra-kahverengi",
    "softhold-capraz-sirt-detayli-atlet-kahverengi",
    "softhold-dikis-detayli-sort-kahverengi",
    "lounge-baglama-bolero-kahverengi"
  ],
  "softhold-buzgulu-halter-bra-gul-kurusu": [
    "softhold-dikis-detayli-tayt-gul-kurusu",
    "softhold-ince-askili-bra-gul-kurusu",
    "softhold-capraz-sirt-detayli-atlet-gul-kurusu",
    "softhold-dikis-detayli-sort-gul-kurusu",
    "lounge-baglama-bolero-gul-kurusu"
  ],
  "softhold-buzgulu-halter-bra-yesil": [
    "softhold-dikis-detayli-tayt-yesil",
    "softhold-ince-askili-bra-yesil",
    "softhold-capraz-sirt-detayli-atlet-yesil",
    "softhold-dikis-detayli-sort-yesil",
    "easemove-sirt-dekolteli-sort-tulum-yesil"
  ],
  "softhold-buzgulu-halter-bra-beyaz": [
    "softhold-ince-askili-bra-beyaz",
    "softhold-capraz-sirt-detayli-atlet-beyaz",
    "lounge-baglama-bolero-ekru",
    "lounge-kabartma-logolu-hoodie-off-white",
    "dossha-shaker"
  ],
  "easemove-fermuarli-sort-tulum-siyah": [
    "softhold-dikis-detayli-tayt-siyah",
    "softhold-ince-askili-bra-siyah",
    "softhold-capraz-sirt-detayli-atlet-siyah",
    "lounge-baglama-bolero-siyah",
    "dossha-logolu-orta-boy-corap-beyaz"
  ],
  "easemove-fermuarli-sort-tulum-kahverengi": [
    "softhold-dikis-detayli-tayt-kahverengi",
    "softhold-ince-askili-bra-kahverengi",
    "softhold-capraz-sirt-detayli-atlet-kahverengi",
    "lounge-baglama-bolero-kahverengi",
    "dossha-shaker"
  ],
  "easemove-sirt-dekolteli-sort-tulum-gul-kurusu": [
    "softhold-dikis-detayli-tayt-gul-kurusu",
    "softhold-ince-askili-bra-gul-kurusu",
    "softhold-capraz-sirt-detayli-atlet-gul-kurusu",
    "lounge-baglama-bolero-gul-kurusu",
    "dossha-logolu-orta-boy-corap-beyaz"
  ],
  "easemove-sirt-dekolteli-sort-tulum-yesil": [
    "softhold-dikis-detayli-tayt-yesil",
    "softhold-ince-askili-bra-yesil",
    "softhold-capraz-sirt-detayli-atlet-yesil",
    "softhold-dikis-detayli-sort-yesil",
    "dossha-shaker"
  ],
  "softhold-dikis-detayli-tayt-siyah": [
    "softhold-ince-askili-bra-siyah",
    "softhold-capraz-sirt-detayli-atlet-siyah",
    "softhold-buzgulu-halter-bra-siyah",
    "softhold-dikis-detayli-sort-siyah",
    "lounge-baglama-bolero-siyah"
  ],
  "softhold-dikis-detayli-tayt-kahverengi": [
    "softhold-ince-askili-bra-kahverengi",
    "softhold-capraz-sirt-detayli-atlet-kahverengi",
    "softhold-buzgulu-halter-bra-kahverengi",
    "softhold-dikis-detayli-sort-kahverengi",
    "lounge-baglama-bolero-kahverengi"
  ],
  "softhold-dikis-detayli-tayt-gul-kurusu": [
    "softhold-ince-askili-bra-gul-kurusu",
    "softhold-capraz-sirt-detayli-atlet-gul-kurusu",
    "softhold-buzgulu-halter-bra-gul-kurusu",
    "softhold-dikis-detayli-sort-gul-kurusu",
    "lounge-baglama-bolero-gul-kurusu"
  ],
  "softhold-dikis-detayli-tayt-yesil": [
    "softhold-ince-askili-bra-yesil",
    "softhold-capraz-sirt-detayli-atlet-yesil",
    "softhold-buzgulu-halter-bra-yesil",
    "softhold-dikis-detayli-sort-yesil",
    "easemove-sirt-dekolteli-sort-tulum-yesil"
  ],
  "softhold-dikis-detayli-sort-siyah": [
    "softhold-dikis-detayli-tayt-siyah",
    "softhold-ince-askili-bra-siyah",
    "softhold-capraz-sirt-detayli-atlet-siyah",
    "softhold-buzgulu-halter-bra-siyah",
    "lounge-baglama-bolero-siyah"
  ],
  "softhold-dikis-detayli-sort-kahverengi": [
    "softhold-dikis-detayli-tayt-kahverengi",
    "softhold-ince-askili-bra-kahverengi",
    "softhold-capraz-sirt-detayli-atlet-kahverengi",
    "softhold-buzgulu-halter-bra-kahverengi",
    "lounge-baglama-bolero-kahverengi"
  ],
  "softhold-dikis-detayli-sort-gul-kurusu": [
    "softhold-dikis-detayli-tayt-gul-kurusu",
    "softhold-ince-askili-bra-gul-kurusu",
    "softhold-capraz-sirt-detayli-atlet-gul-kurusu",
    "softhold-buzgulu-halter-bra-gul-kurusu",
    "lounge-baglama-bolero-gul-kurusu"
  ],
  "softhold-dikis-detayli-sort-yesil": [
    "softhold-dikis-detayli-tayt-yesil",
    "softhold-ince-askili-bra-yesil",
    "softhold-capraz-sirt-detayli-atlet-yesil",
    "softhold-buzgulu-halter-bra-yesil",
    "easemove-sirt-dekolteli-sort-tulum-yesil"
  ],
  "softhold-straplez-bra-mauve": [
    "softhold-sekillendirici-tayt-mauve",
    "softhold-sekillendirici-sort-mauve",
    "softhold-halter-bra-mauve",
    "made-of-sunshine-sapka-krem",
    "dossha-shaker"
  ],
  "softhold-straplez-bra-sand": [
    "softhold-sekillendirici-tayt-sand",
    "softhold-sekillendirici-sort-sand",
    "softhold-halter-bra-sand",
    "made-of-sunshine-sapka-krem",
    "dossha-logolu-orta-boy-corap-beyaz"
  ],
  "softhold-halter-bra-mauve": [
    "softhold-sekillendirici-tayt-mauve",
    "softhold-sekillendirici-sort-mauve",
    "softhold-straplez-bra-mauve",
    "made-of-sunshine-sapka-krem",
    "dossha-shaker"
  ],
  "softhold-halter-bra-sand": [
    "softhold-sekillendirici-tayt-sand",
    "softhold-sekillendirici-sort-sand",
    "softhold-straplez-bra-sand",
    "made-of-sunshine-sapka-krem",
    "dossha-logolu-orta-boy-corap-beyaz"
  ],
  "softhold-sekillendirici-sort-mauve": [
    "softhold-sekillendirici-tayt-mauve",
    "softhold-halter-bra-mauve",
    "softhold-straplez-bra-mauve",
    "made-of-sunshine-sapka-krem",
    "dossha-shaker"
  ],
  "softhold-sekillendirici-sort-sand": [
    "softhold-sekillendirici-tayt-sand",
    "softhold-halter-bra-sand",
    "softhold-straplez-bra-sand",
    "made-of-sunshine-sapka-krem",
    "dossha-logolu-orta-boy-corap-beyaz"
  ],
  "softhold-sekillendirici-tayt-mauve": [
    "softhold-halter-bra-mauve",
    "softhold-sekillendirici-sort-mauve",
    "softhold-straplez-bra-mauve",
    "made-of-sunshine-sapka-krem",
    "dossha-shaker"
  ],
  "softhold-sekillendirici-tayt-sand": [
    "softhold-halter-bra-sand",
    "softhold-sekillendirici-sort-sand",
    "softhold-straplez-bra-sand",
    "made-of-sunshine-sapka-krem",
    "dossha-logolu-orta-boy-corap-beyaz"
  ],
  "lounge-baglama-bolero-ekru": [
    "softhold-ince-askili-bra-beyaz",
    "softhold-capraz-sirt-detayli-atlet-beyaz",
    "softhold-buzgulu-halter-bra-beyaz",
    "lounge-kabartma-logolu-hoodie-off-white",
    "maxi-toka-vanilya"
  ],
  "lounge-baglama-bolero-gul-kurusu": [
    "softhold-dikis-detayli-tayt-gul-kurusu",
    "softhold-ince-askili-bra-gul-kurusu",
    "softhold-capraz-sirt-detayli-atlet-gul-kurusu",
    "softhold-dikis-detayli-sort-gul-kurusu",
    "dossha-logolu-orta-boy-corap-beyaz"
  ],
  "lounge-baglama-bolero-kahverengi": [
    "softhold-dikis-detayli-tayt-kahverengi",
    "softhold-ince-askili-bra-kahverengi",
    "softhold-capraz-sirt-detayli-atlet-kahverengi",
    "softhold-dikis-detayli-sort-kahverengi",
    "dossha-shaker"
  ],
  "lounge-baglama-bolero-siyah": [
    "softhold-dikis-detayli-tayt-siyah",
    "softhold-ince-askili-bra-siyah",
    "softhold-capraz-sirt-detayli-atlet-siyah",
    "softhold-dikis-detayli-sort-siyah",
    "dossha-logolu-orta-boy-corap-beyaz"
  ],
  "easemove-tenis-elbisesi-beyaz": [
    "tenis-sapka-koyu-yesil",
    "easemove-halter-burgu-bra-ekru",
    "easemove-tenis-etegi-ekru",
    "lounge-omuz-bolero-ekru",
    "dossha-shaker"
  ],
  "easemove-tenis-etegi-ekru": [
    "easemove-halter-burgu-bra-ekru",
    "lounge-omuz-bolero-ekru",
    "easemove-tenis-elbisesi-beyaz",
    "tenis-sapka-koyu-yesil",
    "dossha-shaker"
  ],
  "easemove-halter-burgu-bra-ekru": [
    "easemove-tenis-etegi-ekru",
    "lounge-omuz-bolero-ekru",
    "easemove-tenis-elbisesi-beyaz",
    "tenis-sapka-koyu-yesil",
    "dossha-logolu-orta-boy-corap-beyaz"
  ],
  "lounge-omuz-bolero-ekru": [
    "easemove-halter-burgu-bra-ekru",
    "easemove-tenis-etegi-ekru",
    "easemove-tenis-elbisesi-beyaz",
    "tenis-sapka-koyu-yesil",
    "dossha-shaker"
  ],
  "lounge-self-love-baskili-tisort-off-white": [
    "lounge-kabartma-logolu-jogger-ekru",
    "lounge-kabartma-logolu-sweatshirt-ekru",
    "lounge-logo-nakisli-sort-off-white",
    "sweatshirt-ekru",
    "midi-toka-vanilya"
  ],
  "lounge-cherry-baskili-tisort-off-white": [
    "lounge-kabartma-logolu-jogger-ekru",
    "lounge-kabartma-logolu-sweatshirt-ekru",
    "lounge-logo-nakisli-sort-off-white",
    "sweatshirt-ekru",
    "maxi-toka-vanilya"
  ],
  "lounge-logo-nakisli-crop-tisort-kahverengi": [
    "lounge-logo-nakisli-sort-kahverengi",
    "lounge-kabartma-logolu-hoodie-espresso",
    "lounge-kabartma-logolu-wide-leg-esofman-espresso",
    "browny-sac-bandi",
    "dossha-logolu-orta-boy-corap-beyaz"
  ],
  "lounge-logo-nakisli-crop-tisort-koyu-yesil": [
    "lounge-logo-nakisli-sort-koyu-yesil",
    "softhold-dikis-detayli-tayt-yesil",
    "softhold-ince-askili-bra-yesil",
    "fiyonklu-orta-boy-corap-beyaz-yesil",
    "dossha-shaker"
  ],
  "lounge-logo-nakisli-crop-tisort-off-white": [
    "lounge-logo-nakisli-sort-off-white",
    "lounge-kabartma-logolu-jogger-ekru",
    "lounge-kabartma-logolu-sweatshirt-ekru",
    "lounge-self-love-baskili-tisort-off-white",
    "midi-toka-vanilya"
  ],
  "lounge-logo-nakisli-sort-kahverengi": [
    "lounge-logo-nakisli-crop-tisort-kahverengi",
    "lounge-kabartma-logolu-hoodie-espresso",
    "lounge-kabartma-logolu-wide-leg-esofman-espresso",
    "browny-sac-bandi",
    "dossha-shaker"
  ],
  "lounge-logo-nakisli-sort-koyu-yesil": [
    "lounge-logo-nakisli-crop-tisort-koyu-yesil",
    "softhold-dikis-detayli-sort-yesil",
    "softhold-capraz-sirt-detayli-atlet-yesil",
    "fiyonklu-orta-boy-corap-beyaz-yesil",
    "dossha-logolu-orta-boy-corap-beyaz"
  ],
  "lounge-logo-nakisli-sort-off-white": [
    "lounge-logo-nakisli-crop-tisort-off-white",
    "lounge-kabartma-logolu-jogger-ekru",
    "lounge-kabartma-logolu-sweatshirt-ekru",
    "lounge-cherry-baskili-tisort-off-white",
    "maxi-toka-vanilya"
  ],
  "it-girl-orta-boy-corap-beyaz-kahverengi": [
    "lounge-logo-nakisli-sort-kahverengi",
    "lounge-kabartma-logolu-hoodie-espresso",
    "browny-sac-bandi",
    "dossha-shaker",
    "termos-paslanmaz-celik"
  ],
  "it-girl-orta-boy-corap-beyaz-pembe": [
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-sort-pembe",
    "softhold-bra-pembe",
    "aura-ballerina-pink-tayt",
    "dossha-shaker",
    "termos-paslanmaz-celik"
  ],
  "it-girl-orta-boy-corap-beyaz-yesil": [
    "lounge-logo-nakisli-sort-koyu-yesil",
    "softhold-dikis-detayli-tayt-yesil",
    "softhold-ince-askili-bra-yesil",
    "dossha-shaker",
    "termos-paslanmaz-celik"
  ],
  "fiyonklu-orta-boy-corap-beyaz-pembe": [
    "lounge-baglama-bolero-ballerina-pink",
    "aura-ballerina-pink-sort",
    "softhold-bra-pembe",
    "dossha-shaker",
    "termos-paslanmaz-celik"
  ],
  "fiyonklu-orta-boy-corap-beyaz-yesil": [
    "lounge-logo-nakisli-sort-koyu-yesil",
    "softhold-dikis-detayli-sort-yesil",
    "softhold-capraz-sirt-detayli-atlet-yesil",
    "dossha-shaker",
    "termos-paslanmaz-celik"
  ],
  "fiyonklu-orta-boy-corap-beyaz-turuncu": [
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-sort-turuncu",
    "softhold-bra-turuncu",
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-tayt-turuncu",
    "dossha-shaker",
    "termos-paslanmaz-celik"
  ],
  "tenis-sapka-koyu-yesil": [
    "easemove-tenis-elbisesi-beyaz",
    "easemove-halter-burgu-bra-ekru",
    "easemove-tenis-etegi-ekru",
    "dossha-shaker",
    "termos-paslanmaz-celik"
  ],
  "made-of-sunshine-sapka-krem": [
    "softhold-sekillendirici-tayt-mauve",
    "softhold-halter-bra-mauve",
    "softhold-sekillendirici-sort-sand",
    "dossha-shaker",
    "termos-paslanmaz-celik"
  ],
  "softhold-omuz-bolero-pembe": [
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-tayt-pembe",
    "softhold-bra-pembe",
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-sort-pembe",
    "softhold-sirti-baski-detayli-crop-tisort-pembe",
    "softhold-capraz-askili-bra-pembe"
  ],
  "softhold-omuz-bolero-turuncu": [
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-tayt-turuncu",
    "softhold-bra-turuncu",
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-sort-turuncu",
    "softhold-sirti-baski-detayli-crop-tisort-turuncu",
    "softhold-capraz-askili-bra-turuncu"
  ],
  "softhold-omuz-bolero-beyaz": [
    "softhold-bra-beyaz",
    "softhold-capraz-askili-bra-beyaz",
    "softhold-straplez-bra-beyaz",
    "firmhold-reflektor-logolu-tisort-beyaz",
    "dossha-shaker"
  ],
  "softhold-bra-pembe": [
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-tayt-pembe",
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-sort-pembe",
    "softhold-omuz-bolero-pembe",
    "softhold-sirti-baski-detayli-crop-tisort-pembe",
    "softhold-capraz-askili-bra-pembe"
  ],
  "softhold-bra-turuncu": [
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-tayt-turuncu",
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-sort-turuncu",
    "softhold-omuz-bolero-turuncu",
    "softhold-sirti-baski-detayli-crop-tisort-turuncu",
    "softhold-capraz-askili-bra-turuncu"
  ],
  "softhold-bra-beyaz": [
    "softhold-omuz-bolero-beyaz",
    "softhold-capraz-askili-bra-beyaz",
    "softhold-straplez-bra-beyaz",
    "firmhold-burgulu-bra-beyaz",
    "dossha-logolu-orta-boy-corap-beyaz"
  ],
  "softhold-capraz-askili-bra-pembe": [
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-tayt-pembe",
    "softhold-bra-pembe",
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-sort-pembe",
    "softhold-omuz-bolero-pembe",
    "softhold-sirti-baski-detayli-crop-tisort-pembe"
  ],
  "softhold-capraz-askili-bra-turuncu": [
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-tayt-turuncu",
    "softhold-bra-turuncu",
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-sort-turuncu",
    "softhold-omuz-bolero-turuncu",
    "softhold-sirti-baski-detayli-crop-tisort-turuncu"
  ],
  "softhold-capraz-askili-bra-beyaz": [
    "softhold-bra-beyaz",
    "softhold-omuz-bolero-beyaz",
    "softhold-straplez-bra-beyaz",
    "firmhold-kare-yaka-uzun-kol-crop-beyaz",
    "dossha-shaker"
  ],
  "softhold-straplez-bra-pembe": [
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-tayt-pembe",
    "softhold-bra-pembe",
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-sort-pembe",
    "softhold-omuz-bolero-pembe",
    "softhold-sirti-baski-detayli-crop-tisort-pembe"
  ],
  "softhold-straplez-bra-turuncu": [
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-tayt-turuncu",
    "softhold-bra-turuncu",
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-sort-turuncu",
    "softhold-omuz-bolero-turuncu",
    "softhold-sirti-baski-detayli-crop-tisort-turuncu"
  ],
  "softhold-straplez-bra-beyaz": [
    "softhold-bra-beyaz",
    "softhold-omuz-bolero-beyaz",
    "softhold-capraz-askili-bra-beyaz",
    "firmhold-burgulu-bra-beyaz",
    "dossha-logolu-orta-boy-corap-beyaz"
  ],
  "softhold-buzgulu-ve-ribli-kalca-sekillendirici-tayt-pembe": [
    "softhold-bra-pembe",
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-sort-pembe",
    "softhold-omuz-bolero-pembe",
    "softhold-sirti-baski-detayli-crop-tisort-pembe",
    "softhold-capraz-askili-bra-pembe"
  ],
  "softhold-buzgulu-ve-ribli-kalca-sekillendirici-tayt-turuncu": [
    "softhold-bra-turuncu",
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-sort-turuncu",
    "softhold-omuz-bolero-turuncu",
    "softhold-sirti-baski-detayli-crop-tisort-turuncu",
    "softhold-capraz-askili-bra-turuncu"
  ],
  "softhold-buzgulu-ve-ribli-kalca-sekillendirici-sort-pembe": [
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-tayt-pembe",
    "softhold-bra-pembe",
    "softhold-omuz-bolero-pembe",
    "softhold-sirti-baski-detayli-crop-tisort-pembe",
    "softhold-capraz-askili-bra-pembe"
  ],
  "softhold-buzgulu-ve-ribli-kalca-sekillendirici-sort-turuncu": [
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-tayt-turuncu",
    "softhold-bra-turuncu",
    "softhold-omuz-bolero-turuncu",
    "softhold-sirti-baski-detayli-crop-tisort-turuncu",
    "softhold-capraz-askili-bra-turuncu"
  ],
  "softhold-biyeli-crop-tisort-pembe": [
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-tayt-pembe",
    "softhold-bra-pembe",
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-sort-pembe",
    "softhold-omuz-bolero-pembe",
    "softhold-sirti-baski-detayli-crop-tisort-pembe"
  ],
  "softhold-biyeli-crop-tisort-turuncu": [
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-tayt-turuncu",
    "softhold-bra-turuncu",
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-sort-turuncu",
    "softhold-omuz-bolero-turuncu",
    "softhold-sirti-baski-detayli-crop-tisort-turuncu"
  ],
  "softhold-sirti-baski-detayli-crop-tisort-pembe": [
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-tayt-pembe",
    "softhold-bra-pembe",
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-sort-pembe",
    "softhold-omuz-bolero-pembe",
    "softhold-capraz-askili-bra-pembe"
  ],
  "softhold-sirti-baski-detayli-crop-tisort-turuncu": [
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-tayt-turuncu",
    "softhold-bra-turuncu",
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-sort-turuncu",
    "softhold-omuz-bolero-turuncu",
    "softhold-capraz-askili-bra-turuncu"
  ],
  "termos-paslanmaz-celik": [
    "dossha-shaker",
    "dossha-logolu-orta-boy-corap-beyaz",
    "ciao-amore-sapka-krem",
    "hot-stuff-sapka-baby-blue",
    "dossha-logolu-bilek-boy-corap-beyaz"
  ],
  "softhold-omuz-bolero-butter-yellow": [
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-tayt-butter-yellow",
    "softhold-bra-butter-yellow",
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-sort-butter-yellow",
    "softhold-sirti-baski-detayli-crop-tisort-butter-yellow",
    "softhold-capraz-askili-bra-butter-yellow"
  ],
  "softhold-bra-butter-yellow": [
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-tayt-butter-yellow",
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-sort-butter-yellow",
    "softhold-omuz-bolero-butter-yellow",
    "softhold-sirti-baski-detayli-crop-tisort-butter-yellow",
    "softhold-capraz-askili-bra-butter-yellow"
  ],
  "softhold-capraz-askili-bra-butter-yellow": [
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-tayt-butter-yellow",
    "softhold-bra-butter-yellow",
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-sort-butter-yellow",
    "softhold-omuz-bolero-butter-yellow",
    "softhold-sirti-baski-detayli-crop-tisort-butter-yellow"
  ],
  "softhold-straplez-bra-butter-yellow": [
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-tayt-butter-yellow",
    "softhold-bra-butter-yellow",
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-sort-butter-yellow",
    "softhold-omuz-bolero-butter-yellow",
    "softhold-sirti-baski-detayli-crop-tisort-butter-yellow"
  ],
  "softhold-buzgulu-ve-ribli-kalca-sekillendirici-tayt-butter-yellow": [
    "softhold-bra-butter-yellow",
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-sort-butter-yellow",
    "softhold-omuz-bolero-butter-yellow",
    "softhold-sirti-baski-detayli-crop-tisort-butter-yellow",
    "softhold-capraz-askili-bra-butter-yellow"
  ],
  "softhold-buzgulu-ve-ribli-kalca-sekillendirici-sort-butter-yellow": [
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-tayt-butter-yellow",
    "softhold-bra-butter-yellow",
    "softhold-omuz-bolero-butter-yellow",
    "softhold-sirti-baski-detayli-crop-tisort-butter-yellow",
    "softhold-capraz-askili-bra-butter-yellow"
  ],
  "softhold-biyeli-crop-tisort-butter-yellow": [
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-tayt-butter-yellow",
    "softhold-bra-butter-yellow",
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-sort-butter-yellow",
    "softhold-omuz-bolero-butter-yellow",
    "softhold-sirti-baski-detayli-crop-tisort-butter-yellow"
  ],
  "softhold-sirti-baski-detayli-crop-tisort-butter-yellow": [
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-tayt-butter-yellow",
    "softhold-bra-butter-yellow",
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-sort-butter-yellow",
    "softhold-omuz-bolero-butter-yellow",
    "softhold-capraz-askili-bra-butter-yellow"
  ],
  "softhold-omuz-bolero-lila": [
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-tayt-lila",
    "softhold-bra-lila",
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-sort-lila",
    "softhold-sirti-baski-detayli-crop-tisort-lila",
    "softhold-capraz-askili-bra-lila"
  ],
  "softhold-bra-lila": [
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-tayt-lila",
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-sort-lila",
    "softhold-omuz-bolero-lila",
    "softhold-sirti-baski-detayli-crop-tisort-lila",
    "softhold-capraz-askili-bra-lila"
  ],
  "softhold-capraz-askili-bra-lila": [
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-tayt-lila",
    "softhold-bra-lila",
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-sort-lila",
    "softhold-omuz-bolero-lila",
    "softhold-sirti-baski-detayli-crop-tisort-lila"
  ],
  "softhold-straplez-bra-lila": [
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-tayt-lila",
    "softhold-bra-lila",
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-sort-lila",
    "softhold-omuz-bolero-lila",
    "softhold-sirti-baski-detayli-crop-tisort-lila"
  ],
  "softhold-buzgulu-ve-ribli-kalca-sekillendirici-tayt-lila": [
    "softhold-bra-lila",
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-sort-lila",
    "softhold-omuz-bolero-lila",
    "softhold-sirti-baski-detayli-crop-tisort-lila",
    "softhold-capraz-askili-bra-lila"
  ],
  "softhold-buzgulu-ve-ribli-kalca-sekillendirici-sort-lila": [
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-tayt-lila",
    "softhold-bra-lila",
    "softhold-omuz-bolero-lila",
    "softhold-sirti-baski-detayli-crop-tisort-lila",
    "softhold-capraz-askili-bra-lila"
  ],
  "softhold-biyeli-crop-tisort-lila": [
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-tayt-lila",
    "softhold-bra-lila",
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-sort-lila",
    "softhold-omuz-bolero-lila",
    "softhold-sirti-baski-detayli-crop-tisort-lila"
  ],
  "softhold-sirti-baski-detayli-crop-tisort-lila": [
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-tayt-lila",
    "softhold-bra-lila",
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-sort-lila",
    "softhold-omuz-bolero-lila",
    "softhold-capraz-askili-bra-lila"
  ],
  "softhold-omuz-bolero-saks-mavisi": [
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-tayt-saks-mavisi",
    "softhold-bra-saks-mavisi",
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-sort-saks-mavisi",
    "softhold-sirti-baski-detayli-crop-tisort-saks-mavisi",
    "softhold-capraz-askili-bra-saks-mavisi"
  ],
  "softhold-bra-saks-mavisi": [
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-tayt-saks-mavisi",
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-sort-saks-mavisi",
    "softhold-omuz-bolero-saks-mavisi",
    "softhold-sirti-baski-detayli-crop-tisort-saks-mavisi",
    "softhold-capraz-askili-bra-saks-mavisi"
  ],
  "softhold-capraz-askili-bra-saks-mavisi": [
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-tayt-saks-mavisi",
    "softhold-bra-saks-mavisi",
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-sort-saks-mavisi",
    "softhold-omuz-bolero-saks-mavisi",
    "softhold-sirti-baski-detayli-crop-tisort-saks-mavisi"
  ],
  "softhold-straplez-bra-saks-mavisi": [
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-tayt-saks-mavisi",
    "softhold-bra-saks-mavisi",
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-sort-saks-mavisi",
    "softhold-omuz-bolero-saks-mavisi",
    "softhold-sirti-baski-detayli-crop-tisort-saks-mavisi"
  ],
  "softhold-buzgulu-ve-ribli-kalca-sekillendirici-tayt-saks-mavisi": [
    "softhold-bra-saks-mavisi",
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-sort-saks-mavisi",
    "softhold-omuz-bolero-saks-mavisi",
    "softhold-sirti-baski-detayli-crop-tisort-saks-mavisi",
    "softhold-capraz-askili-bra-saks-mavisi"
  ],
  "softhold-buzgulu-ve-ribli-kalca-sekillendirici-sort-saks-mavisi": [
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-tayt-saks-mavisi",
    "softhold-bra-saks-mavisi",
    "softhold-omuz-bolero-saks-mavisi",
    "softhold-sirti-baski-detayli-crop-tisort-saks-mavisi",
    "softhold-capraz-askili-bra-saks-mavisi"
  ],
  "softhold-biyeli-crop-tisort-saks-mavisi": [
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-tayt-saks-mavisi",
    "softhold-bra-saks-mavisi",
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-sort-saks-mavisi",
    "softhold-omuz-bolero-saks-mavisi",
    "softhold-sirti-baski-detayli-crop-tisort-saks-mavisi"
  ],
  "softhold-sirti-baski-detayli-crop-tisort-saks-mavisi": [
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-tayt-saks-mavisi",
    "softhold-bra-saks-mavisi",
    "softhold-buzgulu-ve-ribli-kalca-sekillendirici-sort-saks-mavisi",
    "softhold-omuz-bolero-saks-mavisi",
    "softhold-capraz-askili-bra-saks-mavisi"
  ],
  "firmhold-bra-siyah": [
    "aura-siyah-tayt",
    "firmhold-parmak-detayli-ceket-siyah",
    "firmhold-v-yaka-halter-atlet-siyah",
    "aura-siyah-sort",
    "sac-bandi-siyah"
  ],
  "firmhold-v-yaka-halter-atlet-siyah": [
    "aura-siyah-tayt",
    "firmhold-bra-siyah",
    "firmhold-parmak-detayli-ceket-siyah",
    "aura-siyah-sort",
    "sac-bandi-siyah"
  ],
  "firmhold-parmak-detayli-ceket-siyah": [
    "aura-siyah-tayt",
    "firmhold-bra-siyah",
    "firmhold-v-yaka-halter-atlet-siyah",
    "aura-siyah-sort",
    "sac-bandi-siyah"
  ],
  "aura-siyah-tayt": [
    "firmhold-bra-siyah",
    "firmhold-parmak-detayli-ceket-siyah",
    "firmhold-v-yaka-halter-atlet-siyah",
    "aura-siyah-sort",
    "sac-bandi-siyah"
  ],
  "aura-siyah-sort": [
    "aura-siyah-tayt",
    "firmhold-bra-siyah",
    "firmhold-parmak-detayli-ceket-siyah",
    "firmhold-v-yaka-halter-atlet-siyah",
    "sac-bandi-siyah"
  ],
  "firmhold-sekillendirici-flare-pantolon-siyah": [
    "firmhold-bra-siyah",
    "firmhold-parmak-detayli-ceket-siyah",
    "firmhold-v-yaka-halter-atlet-siyah",
    "aura-siyah-tayt",
    "sac-bandi-siyah"
  ],
  "firmhold-flare-tulum-siyah": [
    "firmhold-bra-siyah",
    "firmhold-parmak-detayli-ceket-siyah",
    "firmhold-v-yaka-halter-atlet-siyah",
    "sac-bandi-siyah",
    "dossha-logolu-orta-boy-corap-beyaz"
  ],
  "firmhold-bra-ballerina-pink": [
    "aura-ballerina-pink-tayt",
    "firmhold-parmak-detayli-ceket-ballerina-pink",
    "firmhold-v-yaka-halter-atlet-ballerina-pink",
    "aura-ballerina-pink-sort",
    "sac-bandi-ballerina-pink"
  ],
  "firmhold-v-yaka-halter-atlet-ballerina-pink": [
    "aura-ballerina-pink-tayt",
    "firmhold-bra-ballerina-pink",
    "firmhold-parmak-detayli-ceket-ballerina-pink",
    "aura-ballerina-pink-sort",
    "sac-bandi-ballerina-pink"
  ],
  "firmhold-parmak-detayli-ceket-ballerina-pink": [
    "aura-ballerina-pink-tayt",
    "firmhold-bra-ballerina-pink",
    "firmhold-v-yaka-halter-atlet-ballerina-pink",
    "aura-ballerina-pink-sort",
    "sac-bandi-ballerina-pink"
  ],
  "aura-ballerina-pink-tayt": [
    "firmhold-bra-ballerina-pink",
    "firmhold-parmak-detayli-ceket-ballerina-pink",
    "firmhold-v-yaka-halter-atlet-ballerina-pink",
    "aura-ballerina-pink-sort",
    "sac-bandi-ballerina-pink"
  ],
  "aura-ballerina-pink-sort": [
    "aura-ballerina-pink-tayt",
    "firmhold-bra-ballerina-pink",
    "firmhold-parmak-detayli-ceket-ballerina-pink",
    "firmhold-v-yaka-halter-atlet-ballerina-pink",
    "sac-bandi-ballerina-pink"
  ],
  "firmhold-sekillendirici-flare-pantolon-ballerina-pink": [
    "firmhold-bra-ballerina-pink",
    "firmhold-parmak-detayli-ceket-ballerina-pink",
    "firmhold-v-yaka-halter-atlet-ballerina-pink",
    "aura-ballerina-pink-tayt",
    "sac-bandi-ballerina-pink"
  ],
  "firmhold-bra-espresso": [
    "aura-espresso-tayt",
    "firmhold-parmak-detayli-ceket-espresso",
    "firmhold-v-yaka-halter-atlet-espresso",
    "aura-espresso-sort",
    "sac-bandi-espresso"
  ],
  "firmhold-v-yaka-halter-atlet-espresso": [
    "aura-espresso-tayt",
    "firmhold-bra-espresso",
    "firmhold-parmak-detayli-ceket-espresso",
    "aura-espresso-sort",
    "sac-bandi-espresso"
  ],
  "firmhold-parmak-detayli-ceket-espresso": [
    "aura-espresso-tayt",
    "firmhold-bra-espresso",
    "firmhold-v-yaka-halter-atlet-espresso",
    "aura-espresso-sort",
    "sac-bandi-espresso"
  ],
  "aura-espresso-tayt": [
    "firmhold-bra-espresso",
    "firmhold-parmak-detayli-ceket-espresso",
    "firmhold-v-yaka-halter-atlet-espresso",
    "aura-espresso-sort",
    "sac-bandi-espresso"
  ],
  "aura-espresso-sort": [
    "aura-espresso-tayt",
    "firmhold-bra-espresso",
    "firmhold-parmak-detayli-ceket-espresso",
    "firmhold-v-yaka-halter-atlet-espresso",
    "sac-bandi-espresso"
  ],
  "firmhold-sekillendirici-flare-pantolon-espresso": [
    "firmhold-bra-espresso",
    "firmhold-parmak-detayli-ceket-espresso",
    "firmhold-v-yaka-halter-atlet-espresso",
    "aura-espresso-tayt",
    "sac-bandi-espresso"
  ],
  "firmhold-flare-tulum-espresso": [
    "firmhold-bra-espresso",
    "firmhold-parmak-detayli-ceket-espresso",
    "firmhold-v-yaka-halter-atlet-espresso",
    "sac-bandi-espresso",
    "dossha-shaker"
  ],
  "lounge-kabartma-logolu-jogger-ekru": [
    "lounge-kabartma-logolu-sweatshirt-ekru",
    "lounge-self-love-baskili-tisort-off-white",
    "lounge-cherry-baskili-tisort-off-white",
    "lounge-logo-nakisli-crop-tisort-off-white",
    "midi-toka-vanilya"
  ],
  "lounge-kabartma-logolu-sweatshirt-ekru": [
    "lounge-kabartma-logolu-jogger-ekru",
    "lounge-self-love-baskili-tisort-off-white",
    "lounge-cherry-baskili-tisort-off-white",
    "lounge-logo-nakisli-sort-off-white",
    "maxi-toka-vanilya"
  ],
  "lounge-kabartma-logolu-jogger-gri-melanj": [
    "lounge-kabartma-logolu-sweatshirt-gri-melanj",
    "lounge-kabartma-logolu-hoodie-gri-melanj",
    "lounge-kabartma-logolu-wide-leg-esofman-gri-melanj",
    "sweatshirt-gri",
    "dossha-logolu-orta-boy-corap-beyaz"
  ],
  "lounge-kabartma-logolu-sweatshirt-gri-melanj": [
    "lounge-kabartma-logolu-jogger-gri-melanj",
    "lounge-kabartma-logolu-hoodie-gri-melanj",
    "lounge-kabartma-logolu-wide-leg-esofman-gri-melanj",
    "sweatshirt-gri",
    "dossha-shaker"
  ],
  "lounge-kabartma-logolu-hoodie-espresso": [
    "lounge-kabartma-logolu-wide-leg-esofman-espresso",
    "aura-espresso-tayt",
    "firmhold-bra-espresso",
    "it-girl-orta-boy-corap-beyaz-kahverengi",
    "dossha-logolu-orta-boy-corap-beyaz"
  ],
  "lounge-kabartma-logolu-wide-leg-esofman-espresso": [
    "lounge-kabartma-logolu-hoodie-espresso",
    "aura-espresso-tayt",
    "firmhold-bra-espresso",
    "it-girl-orta-boy-corap-beyaz-kahverengi",
    "dossha-shaker"
  ],
  "lounge-kabartma-logolu-hoodie-gri-melanj": [
    "lounge-kabartma-logolu-wide-leg-esofman-gri-melanj",
    "lounge-kabartma-logolu-jogger-gri-melanj",
    "lounge-kabartma-logolu-sweatshirt-gri-melanj",
    "sweatshirt-gri",
    "dossha-logolu-orta-boy-corap-beyaz"
  ],
  "lounge-kabartma-logolu-wide-leg-esofman-gri-melanj": [
    "lounge-kabartma-logolu-hoodie-gri-melanj",
    "lounge-kabartma-logolu-jogger-gri-melanj",
    "lounge-kabartma-logolu-sweatshirt-gri-melanj",
    "sweatshirt-gri",
    "dossha-shaker"
  ],
  "sac-bandi-siyah": [
    "aura-siyah-tayt",
    "firmhold-bra-siyah",
    "firmhold-parmak-detayli-ceket-siyah",
    "firmhold-v-yaka-halter-atlet-siyah",
    "dossha-shaker"
  ],
  "sac-bandi-ballerina-pink": [
    "aura-ballerina-pink-tayt",
    "firmhold-bra-ballerina-pink",
    "firmhold-parmak-detayli-ceket-ballerina-pink",
    "firmhold-v-yaka-halter-atlet-ballerina-pink",
    "dossha-logolu-orta-boy-corap-beyaz"
  ],
  "sac-bandi-espresso": [
    "aura-espresso-tayt",
    "firmhold-bra-espresso",
    "firmhold-parmak-detayli-ceket-espresso",
    "firmhold-v-yaka-halter-atlet-espresso",
    "dossha-shaker"
  ],
  "dossha-logolu-bilek-boy-corap-beyaz": [
    "dossha-shaker",
    "termos-paslanmaz-celik",
    "dossha-logolu-orta-boy-corap-beyaz",
    "timeless-sac-bandi",
    "sac-bandi-siyah"
  ],
  "hedi̇ye-karti": [
    "dossha-shaker",
    "termos-paslanmaz-celik",
    "hot-stuff-sapka-baby-blue",
    "dossha-logolu-orta-boy-corap-beyaz",
    "timeless-sac-bandi"
  ],
  "lounge-baglama-bolero-ballerina-pink": [
    "aura-ballerina-pink-tayt",
    "firmhold-bra-ballerina-pink",
    "aura-ballerina-pink-sort",
    "fiyonklu-orta-boy-corap-beyaz-pembe",
    "dossha-logolu-orta-boy-corap-beyaz"
  ],
  "sac-bandi-bordo": [
    "aura-bordo-tayt",
    "firmhold-bra-bordo",
    "firmhold-parmak-detayli-ceket-bordo",
    "firmhold-v-yaka-halter-atlet-bordo",
    "maxi-toka-bordo"
  ],
  "firmhold-flare-tulum-bordo": [
    "firmhold-bra-bordo",
    "firmhold-parmak-detayli-ceket-bordo",
    "firmhold-v-yaka-halter-atlet-bordo",
    "sac-bandi-bordo",
    "midi-toka-bordo"
  ],
  "firmhold-sekillendirici-flare-pantolon-bordo": [
    "firmhold-bra-bordo",
    "firmhold-parmak-detayli-ceket-bordo",
    "firmhold-v-yaka-halter-atlet-bordo",
    "aura-bordo-tayt",
    "maxi-toka-bordo"
  ],
  "aura-bordo-sort": [
    "aura-bordo-tayt",
    "firmhold-bra-bordo",
    "firmhold-parmak-detayli-ceket-bordo",
    "firmhold-v-yaka-halter-atlet-bordo",
    "midi-toka-bordo"
  ],
  "aura-bordo-tayt": [
    "firmhold-bra-bordo",
    "firmhold-parmak-detayli-ceket-bordo",
    "firmhold-v-yaka-halter-atlet-bordo",
    "aura-bordo-sort",
    "maxi-toka-bordo"
  ],
  "firmhold-parmak-detayli-ceket-bordo": [
    "aura-bordo-tayt",
    "firmhold-bra-bordo",
    "firmhold-v-yaka-halter-atlet-bordo",
    "aura-bordo-sort",
    "midi-toka-bordo"
  ],
  "firmhold-v-yaka-halter-atlet-bordo": [
    "aura-bordo-tayt",
    "firmhold-bra-bordo",
    "firmhold-parmak-detayli-ceket-bordo",
    "aura-bordo-sort",
    "maxi-toka-bordo"
  ],
  "firmhold-bra-bordo": [
    "aura-bordo-tayt",
    "firmhold-parmak-detayli-ceket-bordo",
    "firmhold-v-yaka-halter-atlet-bordo",
    "aura-bordo-sort",
    "midi-toka-bordo"
  ],
  "sac-bandi-lacivert": [
    "aura-lacivert-tayt",
    "firmhold-bra-lacivert",
    "firmhold-parmak-detayli-ceket-lacivert",
    "firmhold-v-yaka-halter-atlet-lacivert",
    "dossha-shaker"
  ],
  "firmhold-flare-tulum-lacivert": [
    "firmhold-bra-lacivert",
    "firmhold-parmak-detayli-ceket-lacivert",
    "firmhold-v-yaka-halter-atlet-lacivert",
    "sac-bandi-lacivert",
    "dossha-logolu-orta-boy-corap-beyaz"
  ],
  "firmhold-sekillendirici-flare-pantolon-lacivert": [
    "firmhold-bra-lacivert",
    "firmhold-parmak-detayli-ceket-lacivert",
    "firmhold-v-yaka-halter-atlet-lacivert",
    "aura-lacivert-tayt",
    "sac-bandi-lacivert"
  ],
  "aura-lacivert-sort": [
    "aura-lacivert-tayt",
    "firmhold-bra-lacivert",
    "firmhold-parmak-detayli-ceket-lacivert",
    "firmhold-v-yaka-halter-atlet-lacivert",
    "sac-bandi-lacivert"
  ],
  "aura-lacivert-tayt": [
    "firmhold-bra-lacivert",
    "firmhold-parmak-detayli-ceket-lacivert",
    "firmhold-v-yaka-halter-atlet-lacivert",
    "aura-lacivert-sort",
    "sac-bandi-lacivert"
  ],
  "firmhold-parmak-detayli-ceket-lacivert": [
    "aura-lacivert-tayt",
    "firmhold-bra-lacivert",
    "firmhold-v-yaka-halter-atlet-lacivert",
    "aura-lacivert-sort",
    "sac-bandi-lacivert"
  ],
  "firmhold-v-yaka-halter-atlet-lacivert": [
    "aura-lacivert-tayt",
    "firmhold-bra-lacivert",
    "firmhold-parmak-detayli-ceket-lacivert",
    "aura-lacivert-sort",
    "sac-bandi-lacivert"
  ],
  "firmhold-bra-lacivert": [
    "aura-lacivert-tayt",
    "firmhold-parmak-detayli-ceket-lacivert",
    "firmhold-v-yaka-halter-atlet-lacivert",
    "aura-lacivert-sort",
    "sac-bandi-lacivert"
  ],
  "sac-bandi-vanilya": [
    "firmhold-bra-vanilya",
    "firmhold-v-yaka-halter-atlet-vanilya",
    "firmhold-parmak-detayli-ceket-vanilya",
    "firmhold-sekillendirici-flare-pantolon-vanilya",
    "dossha-shaker"
  ],
  "firmhold-sekillendirici-flare-pantolon-vanilya": [
    "firmhold-bra-vanilya",
    "firmhold-parmak-detayli-ceket-vanilya",
    "firmhold-v-yaka-halter-atlet-vanilya",
    "aura-vanilya-sort",
    "sac-bandi-vanilya"
  ],
  "aura-vanilya-sort": [
    "firmhold-bra-vanilya",
    "firmhold-parmak-detayli-ceket-vanilya",
    "firmhold-v-yaka-halter-atlet-vanilya",
    "firmhold-sekillendirici-flare-pantolon-vanilya",
    "sac-bandi-vanilya"
  ],
  "firmhold-parmak-detayli-ceket-vanilya": [
    "firmhold-bra-vanilya",
    "firmhold-v-yaka-halter-atlet-vanilya",
    "aura-vanilya-sort",
    "firmhold-sekillendirici-flare-pantolon-vanilya",
    "sac-bandi-vanilya"
  ],
  "firmhold-v-yaka-halter-atlet-vanilya": [
    "firmhold-bra-vanilya",
    "firmhold-parmak-detayli-ceket-vanilya",
    "aura-vanilya-sort",
    "firmhold-sekillendirici-flare-pantolon-vanilya",
    "sac-bandi-vanilya"
  ],
  "firmhold-bra-vanilya": [
    "firmhold-v-yaka-halter-atlet-vanilya",
    "firmhold-parmak-detayli-ceket-vanilya",
    "aura-vanilya-sort",
    "firmhold-sekillendirici-flare-pantolon-vanilya",
    "sac-bandi-vanilya"
  ],
  "lounge-kabartma-logolu-wide-leg-esofman-off-white": [
    "lounge-kabartma-logolu-hoodie-off-white",
    "firmhold-reflektor-logolu-tisort-beyaz",
    "firmhold-burgulu-bra-beyaz",
    "dossha-logolu-orta-boy-corap-beyaz",
    "termos-paslanmaz-celik"
  ],
  "lounge-kabartma-logolu-hoodie-off-white": [
    "lounge-kabartma-logolu-wide-leg-esofman-off-white",
    "firmhold-reflektor-logolu-tisort-beyaz",
    "firmhold-kare-yaka-uzun-kol-crop-beyaz",
    "dossha-shaker",
    "termos-paslanmaz-celik"
  ],
  "lounge-kabartma-logolu-wide-leg-esofman-siyah": [
    "lounge-kabartma-logolu-hoodie-siyah",
    "aura-siyah-tayt",
    "firmhold-bra-siyah",
    "dossha-logolu-orta-boy-corap-beyaz",
    "termos-paslanmaz-celik"
  ],
  "lounge-kabartma-logolu-hoodie-siyah": [
    "lounge-kabartma-logolu-wide-leg-esofman-siyah",
    "firmhold-parmak-detayli-ceket-siyah",
    "firmhold-v-yaka-halter-atlet-siyah",
    "dossha-shaker",
    "termos-paslanmaz-celik"
  ],
  "firmhold-fonksiyonel-askili-atlet-siyah": [
    "firmhold-dikis-detayli-tayt-siyah",
    "firmhold-capraz-askili-sporcu-bra-siyah",
    "firmhold-dikis-detayli-sort-siyah",
    "logo-nakisli-kanvas-shopper-canta-vanilya"
  ],
  "atmosfer-siyah-buzgulu-atlet": [
    "firmhold-dikis-detayli-tayt-siyah",
    "atmosfer-siyah-buzgulu-bra",
    "firmhold-dikis-detayli-sort-siyah",
    "firmhold-dikis-detayli-kapri-tayt-siyah",
    "firmhold-fonksiyonel-askili-atlet-siyah"
  ],
  "atmosfer-siyah-buzgulu-bra": [
    "firmhold-dikis-detayli-tayt-siyah",
    "atmosfer-siyah-buzgulu-atlet",
    "firmhold-dikis-detayli-kapri-tayt-siyah",
    "firmhold-dikis-detayli-sort-siyah",
    "firmhold-capraz-askili-sporcu-bra-siyah"
  ],
  "firmhold-dikis-detayli-kapri-tayt-siyah": [
    "firmhold-buzgulu-bra-siyah",
    "firmhold-v-yaka-buzgulu-atlet-siyah",
    "firmhold-dikis-detayli-tayt-siyah",
    "logo-nakisli-kanvas-shopper-canta-vanilya"
  ],
  "firmhold-capraz-askili-sporcu-bra-siyah": [
    "firmhold-dikis-detayli-tayt-siyah",
    "firmhold-dikis-detayli-sort-siyah",
    "firmhold-fonksiyonel-askili-atlet-siyah",
    "logo-nakisli-kanvas-shopper-canta-vanilya"
  ],
  "firmhold-dikis-detayli-sort-siyah": [
    "firmhold-capraz-askili-sporcu-bra-siyah",
    "firmhold-dikis-detayli-tayt-siyah",
    "firmhold-fonksiyonel-askili-atlet-siyah",
    "logo-nakisli-kanvas-shopper-canta-vanilya"
  ],
  "firmhold-dikis-detayli-tayt-siyah": [
    "firmhold-capraz-askili-sporcu-bra-siyah",
    "firmhold-dikis-detayli-sort-siyah",
    "firmhold-fonksiyonel-askili-atlet-siyah",
    "logo-nakisli-kanvas-shopper-canta-vanilya"
  ],
  "firmhold-fonksiyonel-askili-atlet-olive-green": [
    "firmhold-dikis-detayli-tayt-olive-green",
    "firmhold-capraz-askili-sporcu-bra-olive-green",
    "firmhold-dikis-detayli-sort-olive-green",
    "logo-nakisli-kanvas-shopper-canta-vanilya"
  ],
  "atmosfer-haki-buzgulu-bra": [
    "firmhold-dikis-detayli-tayt-olive-green",
    "atmosfer-haki-sekilendirici-tayt",
    "firmhold-fonksiyonel-askili-atlet-olive-green",
    "firmhold-dikis-detayli-sort-olive-green",
    "sac-bandi-olive-green"
  ],
  "firmhold-capraz-askili-sporcu-bra-olive-green": [
    "firmhold-dikis-detayli-tayt-olive-green",
    "firmhold-dikis-detayli-sort-olive-green",
    "firmhold-fonksiyonel-askili-atlet-olive-green",
    "logo-nakisli-kanvas-shopper-canta-vanilya"
  ],
  "atmosfer-haki-sekilendirici-tayt": [
    "firmhold-buzgulu-bra-olive-green",
    "firmhold-dikis-detayli-tayt-olive-green",
    "sac-bandi-olive-green",
    "logo-nakisli-kanvas-shopper-canta-vanilya"
  ],
  "firmhold-dikis-detayli-sort-olive-green": [
    "firmhold-capraz-askili-sporcu-bra-olive-green",
    "firmhold-dikis-detayli-tayt-olive-green",
    "firmhold-fonksiyonel-askili-atlet-olive-green",
    "logo-nakisli-kanvas-shopper-canta-vanilya"
  ],
  "firmhold-dikis-detayli-tayt-olive-green": [
    "firmhold-capraz-askili-sporcu-bra-olive-green",
    "firmhold-dikis-detayli-sort-olive-green",
    "firmhold-fonksiyonel-askili-atlet-olive-green",
    "logo-nakisli-kanvas-shopper-canta-vanilya"
  ],
  "sac-bandi-olive-green": [
    "firmhold-dikis-detayli-tayt-olive-green",
    "firmhold-capraz-askili-sporcu-bra-olive-green",
    "firmhold-fonksiyonel-askili-atlet-olive-green",
    "logo-nakisli-kanvas-shopper-canta-vanilya"
  ],
  "firmhold-fonksiyonel-askili-atlet-espresso": [
    "firmhold-dikis-detayli-kapri-tayt-espresso",
    "lounge-beli-katlamali-yoga-pantolonu-espresso",
    "lounge-basic-tisort-espresso",
    "logo-nakisli-kanvas-shopper-canta-vanilya"
  ],
  "atmosfer-espresso-buzgulu-atlet": [
    "firmhold-dikis-detayli-kapri-tayt-espresso",
    "atmosfer-espresso-yoga-pantolon",
    "firmhold-fonksiyonel-askili-atlet-espresso",
    "atmosfer-lounge-basic-tisort-espresso",
    "aura-espresso-tayt"
  ],
  "firmhold-dikis-detayli-kapri-tayt-espresso": [
    "firmhold-v-yaka-buzgulu-atlet-espresso",
    "firmhold-fonksiyonel-askili-atlet-espresso",
    "lounge-basic-tisort-espresso",
    "logo-nakisli-kanvas-shopper-canta-vanilya"
  ],
  "atmosfer-lounge-basic-tisort-espresso": [
    "atmosfer-espresso-yoga-pantolon",
    "firmhold-dikis-detayli-kapri-tayt-espresso",
    "firmhold-fonksiyonel-askili-atlet-espresso",
    "atmosfer-espresso-buzgulu-atlet",
    "firmhold-sekillendirici-flare-pantolon-espresso"
  ],
  "atmosfer-espresso-yoga-pantolon": [
    "atmosfer-lounge-basic-tisort-espresso",
    "firmhold-fonksiyonel-askili-atlet-espresso",
    "firmhold-dikis-detayli-kapri-tayt-espresso",
    "atmosfer-espresso-buzgulu-atlet",
    "firmhold-bra-espresso"
  ],
  "atmosfer-acik-haki-buzgulu-atlet": [
    "firmhold-dikis-detayli-kapri-tayt-acik-haki",
    "firmhold-dikis-detayli-tayt-olive-green",
    "atmosfer-haki-buzgulu-bra",
    "firmhold-dikis-detayli-sort-olive-green",
    "sac-bandi-olive-green"
  ],
  "firmhold-dikis-detayli-kapri-tayt-acik-haki": [
    "firmhold-v-yaka-buzgulu-atlet-acik-haki",
    "firmhold-dikis-detayli-tayt-olive-green",
    "firmhold-capraz-askili-sporcu-bra-olive-green",
    "logo-nakisli-kanvas-shopper-canta-vanilya"
  ],
  "firmhold-fonksiyonel-askili-atlet-ice-blue": [
    "firmhold-dikis-detayli-tayt-ice-blue",
    "firmhold-capraz-askili-sporcu-bra-ice-blue",
    "firmhold-dikis-detayli-sort-ice-blue",
    "logo-nakisli-kanvas-shopper-canta-vanilya"
  ],
  "atmosfer-buz-mavisi-buzgulu-bra": [
    "firmhold-dikis-detayli-tayt-ice-blue",
    "atmosfer-buz-mavisi-sekillendirici-tayt",
    "firmhold-fonksiyonel-askili-atlet-ice-blue",
    "firmhold-dikis-detayli-sort-ice-blue",
    "sac-bandi-ice-blue"
  ],
  "firmhold-capraz-askili-sporcu-bra-ice-blue": [
    "firmhold-dikis-detayli-tayt-ice-blue",
    "firmhold-dikis-detayli-sort-ice-blue",
    "firmhold-fonksiyonel-askili-atlet-ice-blue",
    "logo-nakisli-kanvas-shopper-canta-vanilya"
  ],
  "atmosfer-buz-mavisi-sekillendirici-tayt": [
    "firmhold-buzgulu-bra-ice-blue",
    "firmhold-dikis-detayli-tayt-ice-blue",
    "sac-bandi-ice-blue",
    "logo-nakisli-kanvas-shopper-canta-vanilya"
  ],
  "firmhold-dikis-detayli-sort-ice-blue": [
    "firmhold-capraz-askili-sporcu-bra-ice-blue",
    "firmhold-dikis-detayli-tayt-ice-blue",
    "firmhold-fonksiyonel-askili-atlet-ice-blue",
    "logo-nakisli-kanvas-shopper-canta-vanilya"
  ],
  "firmhold-dikis-detayli-tayt-ice-blue": [
    "firmhold-capraz-askili-sporcu-bra-ice-blue",
    "firmhold-dikis-detayli-sort-ice-blue",
    "firmhold-fonksiyonel-askili-atlet-ice-blue",
    "logo-nakisli-kanvas-shopper-canta-vanilya"
  ],
  "sac-bandi-ice-blue": [
    "firmhold-dikis-detayli-tayt-ice-blue",
    "firmhold-capraz-askili-sporcu-bra-ice-blue",
    "firmhold-fonksiyonel-askili-atlet-ice-blue",
    "logo-nakisli-kanvas-shopper-canta-vanilya"
  ],
  "firmhold-fonksiyonel-askili-atlet-beyaz": [
    "firmhold-capraz-askili-sporcu-bra-beyaz",
    "firmhold-buzgulu-bra-beyaz",
    "firmhold-v-yaka-buzgulu-atlet-beyaz",
    "logo-nakisli-kanvas-shopper-canta-vanilya"
  ],
  "atmosfer-beyaz-buzgulu-atlet": [
    "atmosfer-beyaz-buzgulu-bra",
    "firmhold-capraz-askili-sporcu-bra-beyaz",
    "firmhold-fonksiyonel-askili-atlet-beyaz",
    "firmhold-reflektor-logolu-tisort-beyaz",
    "dossha-shaker"
  ],
  "atmosfer-beyaz-buzgulu-bra": [
    "atmosfer-beyaz-buzgulu-atlet",
    "firmhold-capraz-askili-sporcu-bra-beyaz",
    "firmhold-fonksiyonel-askili-atlet-beyaz",
    "firmhold-burgulu-bra-beyaz",
    "dossha-logolu-orta-boy-corap-beyaz"
  ],
  "firmhold-capraz-askili-sporcu-bra-beyaz": [
    "firmhold-fonksiyonel-askili-atlet-beyaz",
    "firmhold-buzgulu-bra-beyaz",
    "firmhold-v-yaka-buzgulu-atlet-beyaz",
    "logo-nakisli-kanvas-shopper-canta-vanilya"
  ],
  "atmosfer-airflow-parasut-crop-ceket-olive-green": [
    "atmosfer-airflow-parasut-pantolon-olive-green",
    "atmosfer-airflow-parasut-sort-olive-green",
    "atmosfer-airflow-parasut-yarim-fermuarli-ceket-olive-green",
    "firmhold-fonksiyonel-askili-atlet-olive-green",
    "firmhold-dikis-detayli-tayt-olive-green"
  ],
  "atmosfer-airflow-parasut-pantolon-olive-green": [
    "atmosfer-airflow-parasut-crop-ceket-olive-green",
    "atmosfer-airflow-parasut-yarim-fermuarli-ceket-olive-green",
    "atmosfer-airflow-parasut-sort-olive-green",
    "firmhold-fonksiyonel-askili-atlet-olive-green",
    "atmosfer-haki-buzgulu-bra"
  ],
  "atmosfer-airflow-parasut-sort-olive-green": [
    "atmosfer-airflow-parasut-crop-ceket-olive-green",
    "atmosfer-airflow-parasut-yarim-fermuarli-ceket-olive-green",
    "atmosfer-airflow-parasut-pantolon-olive-green",
    "firmhold-capraz-askili-sporcu-bra-olive-green",
    "atmosfer-haki-buzgulu-bra"
  ],
  "atmosfer-airflow-parasut-yarim-fermuarli-ceket-olive-green": [
    "atmosfer-airflow-parasut-pantolon-olive-green",
    "atmosfer-airflow-parasut-sort-olive-green",
    "atmosfer-airflow-parasut-crop-ceket-olive-green",
    "firmhold-fonksiyonel-askili-atlet-olive-green",
    "firmhold-dikis-detayli-tayt-olive-green"
  ],
  "atmosfer-airflow-parasut-crop-ceket-siyah": [
    "atmosfer-airflow-parasut-pantolon-siyah",
    "atmosfer-airflow-parasut-sort-siyah",
    "atmosfer-airflow-parasut-yarim-fermuarli-ceket-siyah",
    "firmhold-fonksiyonel-askili-atlet-siyah",
    "firmhold-dikis-detayli-tayt-siyah"
  ],
  "atmosfer-airflow-parasut-pantolon-siyah": [
    "atmosfer-airflow-parasut-crop-ceket-siyah",
    "atmosfer-airflow-parasut-yarim-fermuarli-ceket-siyah",
    "atmosfer-airflow-parasut-sort-siyah",
    "firmhold-fonksiyonel-askili-atlet-siyah",
    "atmosfer-siyah-buzgulu-bra"
  ],
  "atmosfer-airflow-parasut-sort-siyah": [
    "atmosfer-airflow-parasut-crop-ceket-siyah",
    "atmosfer-airflow-parasut-yarim-fermuarli-ceket-siyah",
    "atmosfer-airflow-parasut-pantolon-siyah",
    "firmhold-capraz-askili-sporcu-bra-siyah",
    "atmosfer-siyah-buzgulu-bra"
  ],
  "atmosfer-airflow-parasut-yarim-fermuarli-ceket-siyah": [
    "atmosfer-airflow-parasut-pantolon-siyah",
    "atmosfer-airflow-parasut-sort-siyah",
    "atmosfer-airflow-parasut-crop-ceket-siyah",
    "firmhold-fonksiyonel-askili-atlet-siyah",
    "firmhold-dikis-detayli-tayt-siyah"
  ],
  "atmosfer-lounge-basic-tisort-siyah": [
    "atmosfer-siyah-yoga-pantolon",
    "firmhold-dikis-detayli-tayt-siyah",
    "firmhold-dikis-detayli-kapri-tayt-siyah",
    "firmhold-capraz-askili-sporcu-bra-siyah",
    "firmhold-sekillendirici-flare-pantolon-siyah"
  ],
  "atmosfer-siyah-yoga-pantolon": [
    "atmosfer-lounge-basic-tisort-siyah",
    "firmhold-capraz-askili-sporcu-bra-siyah",
    "atmosfer-siyah-buzgulu-bra",
    "firmhold-dikis-detayli-tayt-siyah",
    "firmhold-bra-siyah"
  ],
  "dssh-logolu-bilek-boy-corap-beyaz": [
    "dssh-logolu-orta-boy-corap-beyaz",
    "firmhold-dikis-detayli-tayt-siyah",
    "firmhold-dikis-detayli-tayt-olive-green",
    "logo-nakisli-kanvas-shopper-canta-vanilya"
  ],
  "firmhold-v-yaka-buzgulu-atlet-siyah": [
    "firmhold-dikis-detayli-kapri-tayt-siyah",
    "firmhold-buzgulu-bra-siyah",
    "firmhold-dikis-detayli-tayt-siyah",
    "logo-nakisli-kanvas-shopper-canta-vanilya"
  ],
  "firmhold-buzgulu-bra-siyah": [
    "firmhold-dikis-detayli-kapri-tayt-siyah",
    "firmhold-v-yaka-buzgulu-atlet-siyah",
    "firmhold-dikis-detayli-tayt-siyah",
    "logo-nakisli-kanvas-shopper-canta-vanilya"
  ],
  "firmhold-buzgulu-bra-olive-green": [
    "atmosfer-haki-sekilendirici-tayt",
    "firmhold-dikis-detayli-tayt-olive-green",
    "sac-bandi-olive-green",
    "logo-nakisli-kanvas-shopper-canta-vanilya"
  ],
  "firmhold-v-yaka-buzgulu-atlet-espresso": [
    "firmhold-dikis-detayli-kapri-tayt-espresso",
    "lounge-beli-katlamali-yoga-pantolonu-espresso",
    "lounge-basic-tisort-espresso",
    "logo-nakisli-kanvas-shopper-canta-vanilya"
  ],
  "firmhold-v-yaka-buzgulu-atlet-acik-haki": [
    "firmhold-dikis-detayli-kapri-tayt-acik-haki",
    "firmhold-dikis-detayli-tayt-olive-green",
    "firmhold-capraz-askili-sporcu-bra-olive-green",
    "logo-nakisli-kanvas-shopper-canta-vanilya"
  ],
  "firmhold-buzgulu-bra-ice-blue": [
    "atmosfer-buz-mavisi-sekillendirici-tayt",
    "firmhold-dikis-detayli-tayt-ice-blue",
    "sac-bandi-ice-blue",
    "logo-nakisli-kanvas-shopper-canta-vanilya"
  ],
  "firmhold-v-yaka-buzgulu-atlet-beyaz": [
    "firmhold-buzgulu-bra-beyaz",
    "firmhold-capraz-askili-sporcu-bra-beyaz",
    "firmhold-fonksiyonel-askili-atlet-beyaz",
    "logo-nakisli-kanvas-shopper-canta-vanilya"
  ],
  "firmhold-buzgulu-bra-beyaz": [
    "firmhold-v-yaka-buzgulu-atlet-beyaz",
    "firmhold-capraz-askili-sporcu-bra-beyaz",
    "firmhold-fonksiyonel-askili-atlet-beyaz",
    "logo-nakisli-kanvas-shopper-canta-vanilya"
  ],
  "airflow-parasut-crop-ceket-olive-green": [
    "airflow-parasut-pantolon-olive-green",
    "airflow-parasut-yarim-fermuarli-ceket-olive-green",
    "airflow-parasut-sort-olive-green",
    "logo-nakisli-kanvas-shopper-canta-vanilya"
  ],
  "airflow-parasut-pantolon-olive-green": [
    "airflow-parasut-crop-ceket-olive-green",
    "firmhold-buzgulu-bra-olive-green",
    "airflow-parasut-sort-olive-green",
    "logo-nakisli-kanvas-shopper-canta-vanilya"
  ],
  "airflow-parasut-sort-olive-green": [
    "airflow-parasut-yarim-fermuarli-ceket-olive-green",
    "firmhold-buzgulu-bra-olive-green",
    "airflow-parasut-crop-ceket-olive-green",
    "logo-nakisli-kanvas-shopper-canta-vanilya"
  ],
  "airflow-parasut-yarim-fermuarli-ceket-olive-green": [
    "airflow-parasut-sort-olive-green",
    "airflow-parasut-pantolon-olive-green",
    "airflow-parasut-crop-ceket-olive-green",
    "logo-nakisli-kanvas-shopper-canta-vanilya"
  ],
  "airflow-parasut-crop-ceket-siyah": [
    "airflow-parasut-pantolon-siyah",
    "airflow-parasut-yarim-fermuarli-ceket-siyah",
    "airflow-parasut-sort-siyah",
    "logo-nakisli-kanvas-shopper-canta-vanilya"
  ],
  "airflow-parasut-pantolon-siyah": [
    "airflow-parasut-crop-ceket-siyah",
    "airflow-parasut-yarim-fermuarli-ceket-siyah",
    "airflow-parasut-sort-siyah",
    "logo-nakisli-kanvas-shopper-canta-vanilya"
  ],
  "airflow-parasut-sort-siyah": [
    "airflow-parasut-yarim-fermuarli-ceket-siyah",
    "airflow-parasut-pantolon-siyah",
    "airflow-parasut-crop-ceket-siyah",
    "logo-nakisli-kanvas-shopper-canta-vanilya"
  ],
  "airflow-parasut-yarim-fermuarli-ceket-siyah": [
    "airflow-parasut-sort-siyah",
    "airflow-parasut-pantolon-siyah",
    "airflow-parasut-crop-ceket-siyah",
    "logo-nakisli-kanvas-shopper-canta-vanilya"
  ],
  "lounge-basic-tisort-espresso": [
    "lounge-beli-katlamali-yoga-pantolonu-espresso",
    "firmhold-dikis-detayli-kapri-tayt-espresso",
    "firmhold-fonksiyonel-askili-atlet-espresso",
    "logo-nakisli-kanvas-shopper-canta-vanilya"
  ],
  "lounge-beli-katlamali-yoga-pantolonu-espresso": [
    "lounge-basic-tisort-espresso",
    "firmhold-dikis-detayli-kapri-tayt-espresso",
    "firmhold-fonksiyonel-askili-atlet-espresso",
    "logo-nakisli-kanvas-shopper-canta-vanilya"
  ],
  "lounge-basic-tisort-siyah": [
    "lounge-beli-katlamali-yoga-pantolonu-siyah",
    "firmhold-dikis-detayli-tayt-siyah",
    "firmhold-dikis-detayli-sort-siyah",
    "logo-nakisli-kanvas-shopper-canta-vanilya"
  ],
  "lounge-beli-katlamali-yoga-pantolonu-siyah": [
    "lounge-basic-tisort-siyah",
    "firmhold-dikis-detayli-tayt-siyah",
    "firmhold-dikis-detayli-sort-siyah",
    "logo-nakisli-kanvas-shopper-canta-vanilya"
  ],
  "dssh-logolu-orta-boy-corap-beyaz": [
    "dssh-logolu-bilek-boy-corap-beyaz",
    "firmhold-dikis-detayli-tayt-siyah",
    "firmhold-dikis-detayli-tayt-olive-green",
    "logo-nakisli-kanvas-shopper-canta-vanilya"
  ],
  "logo-nakisli-kanvas-shopper-canta-vanilya": [
    "airflow-parasut-yarim-fermuarli-ceket-olive-green",
    "firmhold-dikis-detayli-tayt-olive-green",
    "lounge-basic-tisort-siyah",
    "logo-nakisli-kanvas-shopper-canta-vanilya"
  ],
  "midi-toka-bordo": [
    "maxi-toka-bordo",
    "aura-bordo-tayt",
    "firmhold-bra-bordo",
    "firmhold-yan-kalca-sekillendirici-tayt-deep-red",
    "firmhold-parmak-detayli-ceket-bordo"
  ],
  "maxi-toka-bordo": [
    "midi-toka-bordo",
    "firmhold-bra-bordo",
    "firmhold-parmak-detayli-ceket-bordo",
    "firmhold-v-sirt-detayli-bra-deep-red",
    "firmhold-v-yaka-halter-atlet-bordo"
  ],
  "midi-toka-vanilya": [
    "maxi-toka-vanilya",
    "lounge-kabartma-logolu-jogger-ekru",
    "lounge-kabartma-logolu-sweatshirt-ekru",
    "sweatshirt-ekru",
    "lounge-logo-nakisli-sort-off-white"
  ],
  "maxi-toka-vanilya": [
    "midi-toka-vanilya",
    "lounge-kabartma-logolu-sweatshirt-ekru",
    "lounge-kabartma-logolu-jogger-ekru",
    "lounge-self-love-baskili-tisort-off-white",
    "lounge-cherry-baskili-tisort-off-white"
  ],

  /* Cosmic set tamamlama */
  "firmhold-kare-yaka-halter-atlet-espresso": [
    "firmhold-kare-yaka-bra-espresso",
    "firmhold-ucgen-sirt-detayli-bra-espresso",
    "firmhold-dikis-detayli-tayt-espresso",
    "firmhold-dikis-detayli-sort-espresso"
  ],
  "firmhold-kare-yaka-bra-espresso": [
    "firmhold-dikis-detayli-tayt-espresso",
    "firmhold-dikis-detayli-sort-espresso",
    "firmhold-kare-yaka-halter-atlet-espresso",
    "firmhold-kisa-kol-tisort-espresso"
  ],
  "firmhold-dikis-detayli-tayt-espresso": [
    "firmhold-kare-yaka-bra-espresso",
    "firmhold-ucgen-sirt-detayli-bra-espresso",
    "firmhold-kare-yaka-halter-atlet-espresso",
    "firmhold-kisa-kol-tisort-espresso"
  ],
  "firmhold-kisa-kol-tisort-espresso": [
    "firmhold-kare-yaka-bra-espresso",
    "firmhold-ucgen-sirt-detayli-bra-espresso",
    "firmhold-dikis-detayli-tayt-espresso",
    "firmhold-dikis-detayli-sort-espresso"
  ],
  "firmhold-ucgen-sirt-detayli-bra-espresso": [
    "firmhold-dikis-detayli-tayt-espresso",
    "firmhold-dikis-detayli-sort-espresso",
    "firmhold-kare-yaka-halter-atlet-espresso",
    "firmhold-kisa-kol-tisort-espresso"
  ],
  "firmhold-dikis-detayli-sort-espresso": [
    "firmhold-kare-yaka-bra-espresso",
    "firmhold-ucgen-sirt-detayli-bra-espresso",
    "firmhold-kare-yaka-halter-atlet-espresso",
    "firmhold-kisa-kol-tisort-espresso"
  ],
  "firmhold-buzgulu-sekillendirici-tayt-deep-plum": [
    "firmhold-kare-yaka-bra-deep-plum",
    "firmhold-ucgen-sirt-detayli-bra-deep-plum",
    "firmhold-kare-yaka-halter-atlet-deep-plum",
    "firmhold-kisa-kol-tisort-deep-plum",
    "firmhold-parmak-detayli-ceket-deep-plum"
  ],
  "firmhold-buzgulu-sekillendirici-sort-deep-plum": [
    "firmhold-kare-yaka-bra-deep-plum",
    "firmhold-ucgen-sirt-detayli-bra-deep-plum",
    "firmhold-kare-yaka-halter-atlet-deep-plum",
    "firmhold-kisa-kol-tisort-deep-plum",
    "firmhold-parmak-detayli-ceket-deep-plum"
  ],
  "firmhold-parmak-detayli-ceket-deep-plum": [
    "firmhold-kare-yaka-bra-deep-plum",
    "firmhold-ucgen-sirt-detayli-bra-deep-plum",
    "firmhold-buzgulu-sekillendirici-tayt-deep-plum",
    "firmhold-dikis-detayli-tayt-deep-plum",
    "firmhold-buzgulu-sekillendirici-sort-deep-plum",
    "firmhold-dikis-detayli-sort-deep-plum"
  ],
  "firmhold-kare-yaka-halter-atlet-deep-plum": [
    "firmhold-kare-yaka-bra-deep-plum",
    "firmhold-ucgen-sirt-detayli-bra-deep-plum",
    "firmhold-buzgulu-sekillendirici-tayt-deep-plum",
    "firmhold-dikis-detayli-tayt-deep-plum",
    "firmhold-buzgulu-sekillendirici-sort-deep-plum",
    "firmhold-dikis-detayli-sort-deep-plum",
    "firmhold-parmak-detayli-ceket-deep-plum"
  ],
  "firmhold-kare-yaka-bra-deep-plum": [
    "firmhold-buzgulu-sekillendirici-tayt-deep-plum",
    "firmhold-dikis-detayli-tayt-deep-plum",
    "firmhold-buzgulu-sekillendirici-sort-deep-plum",
    "firmhold-dikis-detayli-sort-deep-plum",
    "firmhold-sekillendirici-flare-pantolon-deep-plum",
    "firmhold-kare-yaka-halter-atlet-deep-plum",
    "firmhold-kisa-kol-tisort-deep-plum",
    "firmhold-parmak-detayli-ceket-deep-plum"
  ],
  "firmhold-sekillendirici-flare-pantolon-deep-plum": [
    "firmhold-kare-yaka-bra-deep-plum",
    "firmhold-ucgen-sirt-detayli-bra-deep-plum",
    "firmhold-kare-yaka-halter-atlet-deep-plum",
    "firmhold-kisa-kol-tisort-deep-plum",
    "firmhold-parmak-detayli-ceket-deep-plum"
  ],
  "firmhold-dikis-detayli-tayt-deep-plum": [
    "firmhold-kare-yaka-bra-deep-plum",
    "firmhold-ucgen-sirt-detayli-bra-deep-plum",
    "firmhold-kare-yaka-halter-atlet-deep-plum",
    "firmhold-kisa-kol-tisort-deep-plum",
    "firmhold-parmak-detayli-ceket-deep-plum"
  ],
  "firmhold-kisa-kol-tisort-deep-plum": [
    "firmhold-kare-yaka-bra-deep-plum",
    "firmhold-ucgen-sirt-detayli-bra-deep-plum",
    "firmhold-buzgulu-sekillendirici-tayt-deep-plum",
    "firmhold-dikis-detayli-tayt-deep-plum",
    "firmhold-buzgulu-sekillendirici-sort-deep-plum",
    "firmhold-dikis-detayli-sort-deep-plum",
    "firmhold-parmak-detayli-ceket-deep-plum"
  ],
  "firmhold-ucgen-sirt-detayli-bra-deep-plum": [
    "firmhold-buzgulu-sekillendirici-tayt-deep-plum",
    "firmhold-dikis-detayli-tayt-deep-plum",
    "firmhold-buzgulu-sekillendirici-sort-deep-plum",
    "firmhold-dikis-detayli-sort-deep-plum",
    "firmhold-sekillendirici-flare-pantolon-deep-plum",
    "firmhold-kare-yaka-halter-atlet-deep-plum",
    "firmhold-kisa-kol-tisort-deep-plum",
    "firmhold-parmak-detayli-ceket-deep-plum"
  ],
  "firmhold-dikis-detayli-sort-deep-plum": [
    "firmhold-kare-yaka-bra-deep-plum",
    "firmhold-ucgen-sirt-detayli-bra-deep-plum",
    "firmhold-kare-yaka-halter-atlet-deep-plum",
    "firmhold-kisa-kol-tisort-deep-plum",
    "firmhold-parmak-detayli-ceket-deep-plum"
  ],
  "firmhold-buzgulu-sekillendirici-tayt-blush-pink": [
    "firmhold-kare-yaka-bra-blush-pink",
    "firmhold-ucgen-sirt-detayli-bra-blush-pink",
    "firmhold-kare-yaka-halter-atlet-blush-pink",
    "firmhold-kisa-kol-tisort-blush-pink",
    "firmhold-parmak-detayli-ceket-blush-pink"
  ],
  "firmhold-buzgulu-sekillendirici-sort-blush-pink": [
    "firmhold-kare-yaka-bra-blush-pink",
    "firmhold-ucgen-sirt-detayli-bra-blush-pink",
    "firmhold-kare-yaka-halter-atlet-blush-pink",
    "firmhold-kisa-kol-tisort-blush-pink",
    "firmhold-parmak-detayli-ceket-blush-pink"
  ],
  "firmhold-parmak-detayli-ceket-blush-pink": [
    "firmhold-kare-yaka-bra-blush-pink",
    "firmhold-ucgen-sirt-detayli-bra-blush-pink",
    "firmhold-buzgulu-sekillendirici-tayt-blush-pink",
    "firmhold-dikis-detayli-tayt-blush-pink",
    "firmhold-buzgulu-sekillendirici-sort-blush-pink",
    "firmhold-dikis-detayli-sort-blush-pink"
  ],
  "firmhold-kare-yaka-halter-atlet-blush-pink": [
    "firmhold-kare-yaka-bra-blush-pink",
    "firmhold-ucgen-sirt-detayli-bra-blush-pink",
    "firmhold-buzgulu-sekillendirici-tayt-blush-pink",
    "firmhold-dikis-detayli-tayt-blush-pink",
    "firmhold-buzgulu-sekillendirici-sort-blush-pink",
    "firmhold-dikis-detayli-sort-blush-pink",
    "firmhold-parmak-detayli-ceket-blush-pink"
  ],
  "firmhold-kare-yaka-bra-blush-pink": [
    "firmhold-buzgulu-sekillendirici-tayt-blush-pink",
    "firmhold-dikis-detayli-tayt-blush-pink",
    "firmhold-buzgulu-sekillendirici-sort-blush-pink",
    "firmhold-dikis-detayli-sort-blush-pink",
    "firmhold-sekillendirici-flare-pantolon-blush-pink",
    "firmhold-kare-yaka-halter-atlet-blush-pink",
    "firmhold-kisa-kol-tisort-blush-pink",
    "firmhold-parmak-detayli-ceket-blush-pink"
  ],
  "firmhold-sekillendirici-flare-pantolon-blush-pink": [
    "firmhold-kare-yaka-bra-blush-pink",
    "firmhold-ucgen-sirt-detayli-bra-blush-pink",
    "firmhold-kare-yaka-halter-atlet-blush-pink",
    "firmhold-kisa-kol-tisort-blush-pink",
    "firmhold-parmak-detayli-ceket-blush-pink"
  ],
  "firmhold-dikis-detayli-tayt-blush-pink": [
    "firmhold-kare-yaka-bra-blush-pink",
    "firmhold-ucgen-sirt-detayli-bra-blush-pink",
    "firmhold-kare-yaka-halter-atlet-blush-pink",
    "firmhold-kisa-kol-tisort-blush-pink",
    "firmhold-parmak-detayli-ceket-blush-pink"
  ],
  "firmhold-kisa-kol-tisort-blush-pink": [
    "firmhold-kare-yaka-bra-blush-pink",
    "firmhold-ucgen-sirt-detayli-bra-blush-pink",
    "firmhold-buzgulu-sekillendirici-tayt-blush-pink",
    "firmhold-dikis-detayli-tayt-blush-pink",
    "firmhold-buzgulu-sekillendirici-sort-blush-pink",
    "firmhold-dikis-detayli-sort-blush-pink",
    "firmhold-parmak-detayli-ceket-blush-pink"
  ],
  "firmhold-ucgen-sirt-detayli-bra-blush-pink": [
    "firmhold-buzgulu-sekillendirici-tayt-blush-pink",
    "firmhold-dikis-detayli-tayt-blush-pink",
    "firmhold-buzgulu-sekillendirici-sort-blush-pink",
    "firmhold-dikis-detayli-sort-blush-pink",
    "firmhold-sekillendirici-flare-pantolon-blush-pink",
    "firmhold-kare-yaka-halter-atlet-blush-pink",
    "firmhold-kisa-kol-tisort-blush-pink",
    "firmhold-parmak-detayli-ceket-blush-pink"
  ],
  "firmhold-dikis-detayli-sort-blush-pink": [
    "firmhold-kare-yaka-bra-blush-pink",
    "firmhold-ucgen-sirt-detayli-bra-blush-pink",
    "firmhold-kare-yaka-halter-atlet-blush-pink",
    "firmhold-kisa-kol-tisort-blush-pink",
    "firmhold-parmak-detayli-ceket-blush-pink"
  ],
  "firmhold-kare-yaka-halter-atlet-siyah": [
    "firmhold-kare-yaka-bra-siyah",
    "firmhold-ucgen-sirt-detayli-bra-siyah"
  ],
  "firmhold-kare-yaka-bra-siyah": [
    "firmhold-kare-yaka-halter-atlet-siyah",
    "firmhold-kisa-kol-tisort-siyah"
  ],
  "firmhold-kisa-kol-tisort-siyah": [
    "firmhold-kare-yaka-bra-siyah",
    "firmhold-ucgen-sirt-detayli-bra-siyah"
  ],
  "firmhold-ucgen-sirt-detayli-bra-siyah": [
    "firmhold-kare-yaka-halter-atlet-siyah",
    "firmhold-kisa-kol-tisort-siyah"
  ]
};

const DOSSHA_PRODUCT_CACHE = {};

function dosshaFormatMoney(cents) {
  const format = window.theme?.settings?.money_format || "\u20BA{{amount}}";
  const amount = cents / 100;
  const formatted = new Intl.NumberFormat(Shopify.locale || "tr-TR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
  return format.replace(/\{\{.*?\}\}/, formatted);
}

function dosshaImageResize(src, size) {
  if (!src) return "";
  return src.replace(/(_\d+x\d+)?(\.(jpg|jpeg|png|gif|webp))/, `_${size}x$2`);
}

if (!customElements.get("dossha-cart-upsell")) {
  class DosshaCartUpsell extends HTMLElement {
    constructor() {
      super();
      this._swiperInstance = null;
      this._abortController = null;
    }

    connectedCallback() {
      this._abortController = new AbortController();
      this.init();
    }

    disconnectedCallback() {
      if (this._abortController) this._abortController.abort();
      if (this._swiperInstance) {
        this._swiperInstance.destroy(true, true);
        this._swiperInstance = null;
      }
    }

    async init() {
      const area = this.dataset.area || "cart-drawer";
      this.classList.add("is-hidden");
      this.innerHTML = "";

      try {
        const cart = await this.fetchCart();
        if (!cart || !cart.items || cart.items.length === 0) return;

        const recHandles = this.computeRecommendations(cart);
        if (recHandles.length === 0) return;

        const products = await this.fetchProducts(recHandles);
        if (products.length === 0) return;

        this.classList.remove("is-hidden");
        this.renderSlider(products, area);
        this.initSwiper();
        this.bindAddButtons();
      } catch (e) {
        if (e.name !== "AbortError") {
          console.error("[DOSSHA Upsell]", e);
          this.classList.add("is-hidden");
        }
      }
    }

    async fetchCart() {
      const resp = await fetch("/cart.js", {
        signal: this._abortController.signal,
      });
      return resp.json();
    }

    computeRecommendations(cart) {
      const cartHandles = new Set(cart.items.map((item) => item.handle));
      const scores = {};
      const PINNED_HANDLE = "logo-nakisli-kanvas-shopper-canta-vanilya";

      // Color-matched tokas; unmatched colors get the general (midi) pair.
      const TOKA_BY_COLOR = {
        bordo: ["midi-toka-bordo", "maxi-toka-bordo"],
        ekru: ["midi-toka-vanilya", "maxi-toka-vanilya"],
      };
      const TOKA_GENERAL = ["midi-toka-vanilya", "midi-toka-bordo"];

      cart.items.forEach((item) => {
        const recs = DOSSHA_REC_MAP[item.handle];
        if (!recs) return;
        recs.forEach((rec, idx) => {
          if (cartHandles.has(rec)) return;
          scores[rec] = (scores[rec] || 0) + (5 - idx);
        });
      });

      const cartText = [...cartHandles].join(" ");
      const matchedTokas = [];
      Object.entries(TOKA_BY_COLOR).forEach(([color, handles]) => {
        if (cartText.includes(color)) matchedTokas.push(...handles);
      });
      const tokaRecs =
        matchedTokas.length > 0 ? matchedTokas : TOKA_GENERAL;

      tokaRecs.forEach((handle) => {
        if (cartHandles.has(handle)) return;
        scores[handle] = (scores[handle] || 0) + 1;
      });

      const ranked = Object.entries(scores)
        .sort((a, b) => b[1] - a[1])
        .map((entry) => entry[0])
        .filter((handle) => handle !== PINNED_HANDLE);

      // Set recs first (Cosmic / map), then tokas, then bag.
      const result = [];
      ranked.forEach((handle) => {
        if (!tokaRecs.includes(handle) && !result.includes(handle)) {
          result.push(handle);
        }
      });
      tokaRecs.forEach((handle) => {
        if (!cartHandles.has(handle) && !result.includes(handle)) {
          result.push(handle);
        }
      });
      if (!cartHandles.has(PINNED_HANDLE)) {
        result.push(PINNED_HANDLE);
      }

      return result.slice(0, 10);
    }

    async fetchProducts(handles) {
      const results = await Promise.all(
        handles.map(async (handle) => {
          if (DOSSHA_PRODUCT_CACHE[handle] === null) {
            console.warn("[DOSSHA Upsell] cached miss:", handle);
            return null;
          }
          if (DOSSHA_PRODUCT_CACHE[handle]) return DOSSHA_PRODUCT_CACHE[handle];
          try {
            const [resp, colorResp] = await Promise.all([
              fetch(`/products/${handle}.js`, {
                signal: this._abortController.signal,
              }),
              fetch(`/products/${handle}?view=renk`, {
                signal: this._abortController.signal,
              }).catch((error) => {
                if (error.name === "AbortError") throw error;
                return null;
              }),
            ]);
            if (!resp.ok) {
              console.warn(
                "[DOSSHA Upsell] fetch failed:",
                handle,
                resp.status,
              );
              DOSSHA_PRODUCT_CACHE[handle] = null;
              return null;
            }
            const product = await resp.json();
            product.renk = "";
            if (colorResp && colorResp.ok) {
              try {
                const renk = JSON.parse(await colorResp.text());
                if (typeof renk === "string") product.renk = renk.trim();
              } catch (error) {
                product.renk = "";
              }
            }
            DOSSHA_PRODUCT_CACHE[handle] = product;
            return product;
          } catch (e) {
            if (e.name !== "AbortError") {
              console.warn("[DOSSHA Upsell] fetch error:", handle, e.message);
              DOSSHA_PRODUCT_CACHE[handle] = null;
              return null;
            }
            throw e;
          }
        }),
      );
      return results.filter(Boolean);
    }

    renderSlider(products, area) {
      const slidesHTML = products
        .map((product) => this.renderCard(product))
        .join("");

      this.innerHTML = `
        <div class="dossha-upsell">
          <div class="dossha-upsell__header">
            <h5 class="dossha-upsell__title">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>
              Setini Tamamla
            </h5>
          </div>
          <div class="dossha-upsell__slider">
            <div class="swiper dossha-upsell__swiper">
              <div class="swiper-wrapper">
                ${slidesHTML}
              </div>
            </div>
            <button class="dossha-upsell__nav dossha-upsell__nav--prev" aria-label="Geri" type="button">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
            </button>
            <button class="dossha-upsell__nav dossha-upsell__nav--next" aria-label="İleri" type="button">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
            </button>
          </div>
        </div>`;
    }

    renderCard(product) {
      const escapeHTML = (value) =>
        String(value ?? "")
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;")
          .replace(/"/g, "&quot;");
      const imgSrc = product.images?.[0]
        ? dosshaImageResize(product.images[0], 900)
        : "";
      const url = `/products/${product.handle}`;
      const hasVariants =
        product.variants &&
        product.variants.length > 1 &&
        !product.has_only_default_variant;
      const firstAvailable =
        product.variants.find((v) => v.available) || product.variants[0];
      const price = firstAvailable.price;
      const comparePrice = firstAvailable.compare_at_price;
      const isOnSale = comparePrice && comparePrice > price;

      let priceHTML = `<span>${dosshaFormatMoney(price)}</span>`;
      if (isOnSale) {
        priceHTML = `<ins>${dosshaFormatMoney(price)}</ins><del>${dosshaFormatMoney(comparePrice)}</del>`;
      }

      let actionsHTML = "";
      if (hasVariants) {
        const anyAvailable = product.variants.some((v) => v.available);
        const firstAvailableVariant = product.variants.find((v) => v.available);

        const options = product.variants
          .map((v) => {
            const label = v.option3 || v.option2 || v.option1 || v.title;
            const isDisabled = !v.available;
            const isSelected = anyAvailable
              ? v.id === firstAvailableVariant.id
              : false;
            return `<option value="${v.id}"${isDisabled ? " disabled" : ""}${isSelected ? " selected" : ""}>${label}${isDisabled ? " - Tükendi" : ""}</option>`;
          })
          .join("");

        const soldOutOption = !anyAvailable
          ? "<option selected disabled>Tükendi</option>"
          : "";
        const selectDisabled = !anyAvailable ? " disabled" : "";
        const btnDisabled = !anyAvailable ? " disabled" : "";
        const btnVariant = anyAvailable
          ? ` data-variant-id="${firstAvailableVariant.id}"`
          : "";
        const btnText = anyAvailable ? "Sepete Ekle" : "Tükendi";

        actionsHTML = `
          <div class="dossha-upsell__select-wrap">
            <select class="dossha-upsell__select" data-product-handle="${product.handle}"${selectDisabled}>
              ${soldOutOption}${options}
            </select>
            <svg class="dossha-upsell__select-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
          <button type="button" class="dossha-upsell__add-btn"${btnVariant} data-product-handle="${product.handle}"${btnDisabled}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
            <span class="dossha-upsell__add-text">${btnText}</span>
          </button>`;
      } else {
        actionsHTML = `
          <button type="button" class="dossha-upsell__add-btn" data-variant-id="${firstAvailable.id}" data-product-handle="${product.handle}">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
            <span class="dossha-upsell__add-text">Sepete Ekle</span>
          </button>`;
      }

      return `
        <div class="swiper-slide dossha-upsell__card">
          <a href="${url}" class="dossha-upsell__card-link" tabindex="-1">
            <div class="dossha-upsell__card-img">
              ${imgSrc ? `<img src="${imgSrc}" alt="${escapeHTML(product.title)}" loading="lazy" width="400" height="533">` : ""}
            </div>
          </a>
          <div class="dossha-upsell__card-body">
            <a href="${url}" class="dossha-upsell__card-link">
              <h6 class="dossha-upsell__card-title"><span class="dossha-upsell__card-title-text">${escapeHTML(product.title)}</span>${product.renk ? `<span class="dossha-upsell__card-color">${escapeHTML(product.renk)}</span>` : ""}</h6>
            </a>
            <div class="dossha-upsell__card-price">${priceHTML}</div>
            <div class="dossha-upsell__card-actions">${actionsHTML}</div>
          </div>
        </div>`;
    }

    initSwiper() {
      const swiperEl = this.querySelector(".dossha-upsell__swiper");
      if (!swiperEl || typeof Swiper === "undefined") return;

      this._swiperInstance = new Swiper(swiperEl, {
        slidesPerView: "auto",
        spaceBetween: 10,
        freeMode: {
          enabled: true,
          sticky: false,
        },
        grabCursor: true,
        watchOverflow: true,
        navigation: {
          prevEl: this.querySelector(".dossha-upsell__nav--prev"),
          nextEl: this.querySelector(".dossha-upsell__nav--next"),
        },
      });
    }

    bindAddButtons() {
      this.querySelectorAll(".dossha-upsell__select").forEach((select) => {
        select.addEventListener("change", () => {
          const card = select.closest(".dossha-upsell__card");
          const addBtn = card.querySelector(".dossha-upsell__add-btn");
          const selected = select.options[select.selectedIndex];
          if (selected && !selected.disabled) {
            addBtn.dataset.variantId = selected.value;
            addBtn.disabled = false;
          } else {
            addBtn.disabled = true;
          }
        });
      });

      this.querySelectorAll(".dossha-upsell__add-btn").forEach((btn) => {
        btn.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          const variantId = btn.dataset.variantId;
          if (!variantId) return;
          this.addToCart(variantId, btn);
        });
      });
    }

    /**
     * Order "Additional details" only (cart attributes). Merges with existing
     * attrs (e.g. segmentify) so we never wipe them. No line-item properties.
     */
    async markCartBoostAttribute(productHandle) {
      try {
        const cart = await this.fetchCart();
        const attrs = Object.assign({}, cart.attributes || {});
        attrs.cart_boost = "true";

        const existing = String(attrs.cart_boost_items || "")
          .split(",")
          .map((s) => s.trim())
          .filter(Boolean);
        if (productHandle && !existing.includes(productHandle)) {
          existing.push(productHandle);
        }
        if (existing.length) {
          attrs.cart_boost_items = existing.join(", ");
        }

        const updateUrl =
          window.routes?.cart_update_url != null
            ? `${window.routes.cart_update_url}.js`
            : "/cart/update.js";

        await fetch(updateUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify({ attributes: attrs }),
          signal: this._abortController?.signal,
        });
      } catch (e) {
        if (e.name !== "AbortError") {
          console.warn("[DOSSHA Upsell] cart_boost attribute failed:", e);
        }
      }
    }

    async addToCart(variantId, btnEl) {
      btnEl.classList.add("is-loading");
      btnEl.disabled = true;

      try {
        const cartDrawer = document.querySelector("cart-drawer");
        const cartItems = document.querySelector("cart-items");
        const cartElement = cartDrawer || cartItems;
        const productHandle = btnEl.dataset.productHandle || "";

        let sectionsParam = [];
        if (
          cartElement &&
          typeof cartElement.getSectionsToRender === "function"
        ) {
          sectionsParam = cartElement
            .getSectionsToRender()
            .map((s) => s.section);
        }

        const formData = new FormData();
        formData.append("id", variantId);
        formData.append("quantity", "1");
        if (sectionsParam.length) {
          formData.append("sections", sectionsParam.join(","));
          formData.append("sections_url", window.location.pathname);
        }

        const response = await fetch(`${routes.cart_add_url}.js`, {
          method: "POST",
          headers: { "X-Requested-With": "XMLHttpRequest" },
          body: formData,
        });

        const result = await response.json();

        if (result.status === 422) {
          btnEl.classList.remove("is-loading");
          btnEl.disabled = false;
          return;
        }

        // Additional details on the order (alongside segmentify_identify, etc.)
        await this.markCartBoostAttribute(productHandle);

        btnEl.classList.remove("is-loading");
        btnEl.classList.add("is-added");
        btnEl.querySelector(".dossha-upsell__add-text").textContent = "Eklendi";

        if (cartDrawer && result.sections) {
          cartDrawer.renderContents(result);
        } else if (cartItems && result.sections) {
          cartElement.getSectionsToRender()?.forEach((section) => {
            const el =
              document.querySelector(section.selector) ||
              document.querySelector(section.id);
            if (el && result.sections[section.section]) {
              el.innerHTML =
                new DOMParser()
                  .parseFromString(
                    result.sections[section.section],
                    "text/html",
                  )
                  .querySelector(section.selector)?.innerHTML || "";
            }
          });
        }

        if (typeof updateCartCounters === "function") updateCartCounters();
        if (typeof updateFreeShipping === "function") updateFreeShipping();
      } catch (error) {
        console.error("[DOSSHA Upsell] Add to cart failed:", error);
        btnEl.classList.remove("is-loading");
        btnEl.disabled = false;
      }
    }
  }

  customElements.define("dossha-cart-upsell", DosshaCartUpsell);
}
